<template>
  <div>
    <loading
      :active.sync="loadingTicket"
      :is-full-page="true"
      color="grey"
    ></loading>
    <!-- <v-toolbar flat color="white">
      <v-btn
        flat
        depressed
        rounded
        @click="addTicketItem()"
        color="primary"
        class="white--text"
        >Add Ticket</v-btn
      >

      <v-btn
        flat
        depressed
        rounded
        @click="clearFilters()"
        color="primary"
        class="white--text"
        >Filter</v-btn
      >
      <v-flex mb-1 v-if="displayContents('calendar1')">
       
        <v-checkbox
          label="System Generated"
          v-model="calendarSystemGenerated"
          hide-details
        ></v-checkbox>
        <v-checkbox
          label="Show Completed Tickets"
          v-model="showCompletedTickets"
          hide-details
        ></v-checkbox>
      </v-flex>
      <v-flex xs3 v-if="displayContents('calendar1')">
        <v-layout>
          <v-flex xs9>
        <v-autocomplete
          v-model="keyComplete"
          :items="categoryItemList"
          prepend-inner-icon="search"
          label="Filter by Category Item"
          item-text="name"
          item-value="name"
          :search-input.sync="searchKeys"
          flat
          color="primary"
          clearable
          @click:clear="clearKeys()"
        >
          <template v-slot:item="data">
            <template v-if="data.item.type === 'category'">
              <v-list-tile-avatar
                @click="filterByCategory(data)"
                style="margin-top: 1px"
              >
                <v-icon contain color="primary">{{ data.item.icon }}</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content @click="filterByCategory(data)">
                <v-list-tile-title>{{ data.item.name }}</v-list-tile-title>
              </v-list-tile-content>
            </template>
            <template v-else>
              <v-layout align-left justify-left>
                <v-list-tile-avatar
                  style="margin-top: 1px; margin-left: 40px"
                  @click="filterByKey(data)"
                >
                  <v-icon contain :color="data.item.colour">circle</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content align-center @click="filterByKey(data)">
                  <v-list-tile-title>{{ data.item.name }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{
                    data.item.code
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-layout>
            </template>
          </template>
        </v-autocomplete>
          </v-flex>
          <v-flex xs3>
         <v-btn  color="primary" class="white--text" round @click="calendarSystemGenerated= null,
      showCompletedTickets= null;fetchCalendar()"><v-icon color="white">refresh</v-icon>Refresh</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-toolbar> -->
    <v-toolbar flat color="white">
      <v-tabs div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs.slice(1)"
          :key="tab.name"
          @click="
            setActiveTabName(tab.name);
            contactId = null;
            contactTableId = null;
          "
          >{{ tab.displayName }}
          <v-chip :key="key" :color="tab.color" class="white--text">{{
            tab.array
          }}</v-chip></v-tab
        >
      </v-tabs>
    </v-toolbar>
    <div class="custom" v-if="displayContents('calendar')">
      <TicketCalendar />
      
    </div>

    <div class="custom" v-if="displayContents('calendar1')">
      <Calendar
        @transition-end="changeCal()"
        ref="calendar"
        class="custom_calendar"
        is-expanded
        :attributes="filteredTickets"
      >
        <template slot="day-content" slot-scope="props">
          <drop
            :key="key"
            @dragover="over = true"
            @dragleave="over = false"
            @drop="dropTicket($event, props.day)"
            class="dropClass"
          >
            <v-card
              flat
              height="100%"
              :class="[
                { 'background-color: grey': over },
                {
                  'background-color: grey lighten-2':
                    props.day.inMonth &&
                    props.day.dateTime < new Date() &&
                    !props.day.isToday,
                },
                { 'background-color: primary lighten-1': props.day.isToday },
                { 'background-color: white': props.day.isToday },
              ]"
            >
              <v-btn
                v-if="
                  sortedDate(
                    new Date(props.day.year, props.day.month - 1, props.day.day)
                  ) === true
                "
                style="cursor: pointer"
                icon
                @click="addTicket(props.day.dateTime)"
                color="grey"
                class="white--text"
                >{{ props.day.day }}</v-btn
              >
              <v-btn v-else style="cursor: pointer" icon color="grey">{{
                props.day.day
              }}</v-btn>
              <v-flex
                xs12
                mt-1
                v-for="dayEvent in props.day.attributesMap"
                :key="dayEvent.customData.id"
              >
                <v-menu open-on-hover top offset-x>
                  <template v-slot:activator="{ on }">
                    <drag
                      @dragstart="handleChildDragstart"
                      :transferData="dayEvent"
                    >
                      <v-card
                        v-on="on"
                        hover
                        flat
                        class="rounded-card"
                        :color="dayEvent.customData.colour"
                        v-if="!dayEvent.customData.isComplete"
                        @click="editTicket(dayEvent.customData.id)"
                      >
                        <v-layout mx-1 pt-1 align-center justify-left>
                          <v-flex xs1 mx-1>
                            <v-icon mx-1 small color="white">{{
                              dayEvent.customData.ticketCategoryItem
                                .ticketCategory.icon
                            }}</v-icon>
                          </v-flex>
                          <v-flex xs9>
                            <h4 class="text white--text text-xs-left">
                              ID: {{ dayEvent.customData.id }}
                            </h4>
                          </v-flex>
                          <!-- <v-spacer></v-spacer> -->
                          <!-- <v-flex xs1  mr-3 mt-1> -->
                          <v-avatar
                            ma-1
                            size="23px"
                            color="grey"
                            class="title white--text"
                            v-if="
                              dayEvent.customData !== null &&
                              dayEvent.customData.assignedTo &&
                              dayEvent.customData.assignedTo != null
                            "
                          >
                            <span class="smallText"
                              >{{ dayEvent.customData.assignedTo.name.charAt(0)
                              }}{{
                                dayEvent.customData.assignedTo.surname.charAt(0)
                              }}</span
                            >
                          </v-avatar>
                          <v-avatar
                            mr-2
                            mt-2
                            size="25px"
                            color="grey"
                            class="title font-weight-light white--text"
                            v-else
                          >
                            <span class="smallText font-weight-bold">?</span>
                          </v-avatar>
                          <!-- </v-flex> -->
                        </v-layout>
                        <v-layout mx-1 py-1 align-center justify-center wrap>
                          <v-flex
                            v-if="dayEvent.customData.ticketCategoryItem"
                            xs10
                            mx-1
                          >
                            <h4 class="text white--text text-xs-left">
                              {{ dayEvent.customData.ticketCategoryItem.name }}
                            </h4>
                          </v-flex>
                          <v-flex xs10 mx-1 v-if="dayEvent.customData.location">
                            <v-layout align-center>
                              <!-- <v-icon color="white">gps_fixed</v-icon> -->
                              <h4
                                class="text white--text text-xs-left font-weight-light"
                              >
                                {{
                                  dayEvent.customData.location.locationNetwork
                                    .name
                                }}
                              </h4>
                            </v-layout>
                          </v-flex>
                          <v-flex
                            xs10
                            mx-1
                            v-else-if="dayEvent.customData.locationNetwork"
                          >
                            <v-layout align-center>
                              <!-- <v-icon color="white">gps_fixed</v-icon> -->
                              <h4
                                class="text white--text text-xs-left font-weight-light"
                              >
                                {{ dayEvent.customData.locationNetwork.name }}
                              </h4>
                            </v-layout>
                          </v-flex>
                          <v-flex xs10 mx-1 v-if="dayEvent.customData.location">
                            <v-layout align-center>
                              <!-- <v-icon color="white">gps_fixed</v-icon> -->
                              <h4
                                class="text white--text text-xs-left font-weight-light"
                              >
                                <v-layout>
                                  <span
                                    v-if="
                                      dayEvent.customData.location.erfNo &&
                                      dayEvent.customData.location.unitNo
                                    "
                                  >
                                    ERF:
                                    {{ dayEvent.customData.location.erfNo }} |
                                    Unit:
                                    {{
                                      dayEvent.customData.location.unitNo
                                    }}</span
                                  >
                                  <span
                                    v-else-if="
                                      dayEvent.customData.location.erfNo
                                    "
                                    >ERF:
                                    {{ dayEvent.customData.location.erfNo }}
                                  </span>
                                  <span
                                    v-else-if="
                                      dayEvent.customData.location.unitNo
                                    "
                                  >
                                    Unit:
                                    {{
                                      dayEvent.customData.location.unitNo
                                    }}</span
                                  >
                                </v-layout>
                              </h4>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout
                          mx-1
                          align-center
                          justify-left
                          v-if="
                            dayEvent.customData.dueTime &&
                            !dayEvent.customData.isSystemGenerated
                          "
                        >
                          <v-spacer></v-spacer>
                          <v-flex xs3 mx-1 pr-3>
                            <h3
                              class="font-weight-light white--text text-xs-right"
                            >
                              {{
                                dayEvent.customData.dueTime.split(":")[0] +
                                ":" +
                                dayEvent.customData.dueTime.split(":")[1]
                              }}
                            </h3>
                          </v-flex>
                        </v-layout>
                      </v-card>
                      <v-card
                        v-on="on"
                        flat
                        class="rounded-card"
                        style="cursor: pointer"
                        color="grey darken-2"
                        v-else
                        @click="editTicket(dayEvent.customData.id)"
                      >
                        <v-layout mx-1 align-center justify-left>
                          <v-flex xs1 mx-1>
                            <v-icon mx-1 small color="white">{{
                              dayEvent.customData.ticketCategoryItem
                                .ticketCategory.icon
                            }}</v-icon>
                          </v-flex>
                          <v-flex xs9>
                            <h4 class="text white--text text-xs-left">
                              ID: {{ dayEvent.customData.id }}
                            </h4>
                          </v-flex>
                          <v-spacer></v-spacer>
                          <v-icon mt-1 mr-1 medium color="light-green"
                            >check_circle</v-icon
                          >
                        </v-layout>
                        <v-layout mx-1 pb-1 align-center justify-center wrap>
                          <v-flex
                            v-if="dayEvent.customData.ticketCategoryItem"
                            xs10
                            mx-1
                          >
                            <h4 class="text white--text text-xs-left">
                              {{ dayEvent.customData.ticketCategoryItem.name }}
                            </h4>
                          </v-flex>
                          <v-flex xs10 mx-1 v-if="dayEvent.customData.location">
                            <v-layout align-center>
                              <!-- <v-icon color="white">gps_fixed</v-icon> -->
                              <h4
                                class="text white--text text-xs-left font-weight-light"
                              >
                                {{
                                  dayEvent.customData.location.locationNetwork
                                    .name
                                }}
                              </h4>
                            </v-layout>
                          </v-flex>
                          <v-flex
                            xs10
                            mx-1
                            v-else-if="dayEvent.customData.locationNetwork"
                          >
                            <v-layout align-center>
                              <!-- <v-icon color="white">gps_fixed</v-icon> -->
                              <h4
                                class="text white--text text-xs-left font-weight-light"
                              >
                                {{ dayEvent.customData.locationNetwork.name }}
                              </h4>
                            </v-layout>
                          </v-flex>
                          <v-flex xs10 mx-1 v-if="dayEvent.customData.location">
                            <v-layout align-center>
                              <!-- <v-icon color="white">gps_fixed</v-icon> -->
                              <h4
                                class="text white--text text-xs-left font-weight-light"
                              >
                                <v-layout>
                                  <span
                                    v-if="
                                      dayEvent.customData.location.erfNo &&
                                      dayEvent.customData.location.unitNo
                                    "
                                  >
                                    ERF:
                                    {{ dayEvent.customData.location.erfNo }} |
                                    Unit:
                                    {{
                                      dayEvent.customData.location.unitNo
                                    }}</span
                                  >
                                  <span
                                    v-else-if="
                                      dayEvent.customData.location.erfNo
                                    "
                                    >ERF:
                                    {{ dayEvent.customData.location.erfNo }}
                                  </span>
                                  <span
                                    v-else-if="
                                      dayEvent.customData.location.unitNo
                                    "
                                  >
                                    Unit:
                                    {{
                                      dayEvent.customData.location.unitNo
                                    }}</span
                                  >
                                </v-layout>
                              </h4>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout
                          mx-1
                          align-center
                          justify-left
                          v-if="
                            dayEvent.customData.dueTime &&
                            !dayEvent.customData.isSystemGenerated
                          "
                        >
                          <v-spacer></v-spacer>
                          <v-flex xs3 mx-1 pr-3>
                            <h3
                              class="font-weight-light white--text text-xs-right"
                            >
                              {{
                                dayEvent.customData.dueTime.split(":")[0] +
                                ":" +
                                dayEvent.customData.dueTime.split(":")[1]
                              }}
                            </h3>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </drag>
                  </template>
                  <v-card width="400px" border-color="red">
                    <v-container grid-list-xs>
                      <v-layout wrap>
                        <v-flex xs12 sm12 md12 text-xs-left>
                          <v-layout justify-left>
                            <v-flex xs6>
                              <h2
                                class="subheading grey--text font-weight-bold"
                              >
                                Ticket ID:
                              </h2>
                            </v-flex>
                            <v-flex xs6>
                              <h3 class="grey--text font-weight-light">
                                {{ dayEvent.customData.id }}
                              </h3>
                            </v-flex>
                          </v-layout>
                          <v-layout
                            v-if="dayEvent.customData.ticketCategoryItem"
                            justify-center
                          >
                            <v-flex xs6>
                              <h2
                                class="subheading grey--text font-weight-bold"
                              >
                                Category:
                              </h2>
                            </v-flex>
                            <v-flex xs6>
                              <h3 class="grey--text font-weight-light">
                                {{
                                  dayEvent.customData.ticketCategoryItem
                                    .ticketCategory.name
                                }}
                              </h3>
                            </v-flex>
                          </v-layout>
                          <v-layout
                            v-if="dayEvent.customData.ticketCategoryItem"
                            justify-center
                          >
                            <v-flex xs6>
                              <h2
                                class="subheading grey--text font-weight-bold"
                              >
                                Subcategory:
                              </h2>
                            </v-flex>
                            <v-flex xs6>
                              <h3 class="grey--text font-weight-light">
                                {{
                                  dayEvent.customData.ticketCategoryItem.name
                                }}
                              </h3>
                            </v-flex>
                          </v-layout>
                          <v-layout
                            justify-center
                            v-if="dayEvent.customData.description"
                          >
                            <v-flex xs6>
                              <h2
                                class="subheading grey--text font-weight-bold"
                              >
                                Description:
                              </h2>
                            </v-flex>
                            <v-flex xs6>
                              <h3
                                class="grey--text font-weight-light"
                                style="
                                  text-overflow: ellipsis;
                                  overflow: hidden;
                                "
                              >
                                {{ dayEvent.customData.description }}
                              </h3>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs6>
                              <h2
                                class="subheading grey--text font-weight-bold"
                              >
                                Due:
                              </h2>
                            </v-flex>
                            <v-flex xs6>
                              <h3
                                class="grey--text font-weight-light"
                                v-if="dayEvent.customData.dueTime === null"
                              >
                                {{ formatDate(dayEvent.customData.dueDate) }}
                              </h3>
                              <h3 class="grey--text font-weight-light" v-else>
                                {{ formatDate(dayEvent.customData.dueDate) }}
                                {{ dayEvent.customData.dueTime }}
                              </h3>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center align-center>
                            <v-flex xs6>
                              <h2
                                class="subheading grey--text font-weight-bold"
                              >
                                Status:
                              </h2>
                            </v-flex>
                            <v-flex xs6>
                              <h3 class="grey--text">
                                <v-chip
                                  small
                                  :class="`${dayEvent.customData.currentStatus
                                    .replace(/\s/g, '')
                                    .toLowerCase()} white--text`"
                                  >{{
                                    dayEvent.customData.currentStatus
                                  }}</v-chip
                                >
                              </h3>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center align-center>
                            <v-flex xs6>
                              <h2
                                class="subheading grey--text font-weight-bold"
                              >
                                Priority:
                              </h2>
                            </v-flex>
                            <v-flex xs6>
                              <h3 class="grey--text">
                                <v-chip
                                  small
                                  :class="`${dayEvent.customData.importance
                                    .replace(/\s/g, '')
                                    .toLowerCase()} white--text`"
                                  >{{ dayEvent.customData.importance }}</v-chip
                                >
                              </h3>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs6>
                              <h2
                                class="subheading grey--text font-weight-bold"
                              >
                                Created By:
                              </h2>
                            </v-flex>
                            <v-flex xs6>
                              <h3 class="grey--text font-weight-light">
                                {{ dayEvent.customData.createdBy.name }}
                                {{ dayEvent.customData.createdBy.surname }}
                              </h3>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs6>
                              <h2
                                class="subheading grey--text font-weight-bold"
                              >
                                Assigned To:
                              </h2>
                            </v-flex>
                            <v-flex xs6>
                              <h3
                                v-if="dayEvent.customData.assignedTo !== null"
                                class="grey--text font-weight-light"
                              >
                                {{ dayEvent.customData.assignedTo.name }}
                                {{ dayEvent.customData.assignedTo.surname }}
                              </h3>
                              <h3 v-else class="grey--text font-weight-light">
                                Unassigned
                              </h3>
                            </v-flex>
                          </v-layout>
                          <v-layout
                            justify-center
                            v-if="dayEvent.customData.resolvedBy !== null"
                          >
                            <v-flex xs6>
                              <h2
                                class="subheading grey--text font-weight-bold"
                              >
                                Resolved By:
                              </h2>
                            </v-flex>
                            <v-flex xs6>
                              <h3 class="grey--text font-weight-light">
                                {{ dayEvent.customData.resolvedBy.name }}
                                {{ dayEvent.customData.resolvedBy.surname }}
                              </h3>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-menu>
              </v-flex>
              <v-card-actions>
                <v-layout
                  justify-center
                  v-if="
                    props.day.attributesMap &&
                    calculateMoreShow(props.day, props.day.id) === true
                  "
                >
                  <!-- allFilteredTickets.filter(x=>
                (showCompletedTickets==x.customData.isComplete)&&
                (calendarSystemGenerated==x.customData.isSystemGenerated)
                && x.dates==props.day.id).length>3 
                " -->

                  <v-btn
                    color="#8197b5"
                    round
                    class="white--text"
                    v-if="
                      calculateMore(props.day.id, props.day.attributesMap) ===
                      true&&!loadingMore
                    "
                    @click="loadingMore = true;
                      showMoreButton(props.day.id, props.day.attributesMap)
                    "
                    >Show More</v-btn
                  >
                   
                  <v-btn
                    color="#8197b5"
                    round
                    class="white--text"
                    v-else-if="
                      calculateMore(props.day.id, props.day.attributesMap) ===
                      false&&!loadingMore
                    "
                    @click="loadingMore = true;
                      showLessButton(props.day.id, props.day.attributesMap)
                    "
                    >Show Less</v-btn
                  >
                   <v-btn v-else-if="loadingMore" round disabled>
                          <span>Loading  </span>  <v-progress-circular
                          size="20"
                          indeterminate
                          color="white"
                        ></v-progress-circular></v-btn>
                </v-layout>
              </v-card-actions>
              <!-- <v-card-actions v-else>
                <v-layout justify-center v-if="props.day.attributesMap&&calculateMoreShow(props.day.id)===true
                ">
                  <v-btn color="#8197b5" round class="white--text" v-if="calculateMore(props.day.id, props.day.attributesMap)===true" @click="showMoreButton(props.day.id, props.day.attributesMap)">Show More</v-btn>
                  <v-btn color="#8197b5" round class="white--text" v-else-if="calculateMore(props.day.id, props.day.attributesMap)===false" @click="showLessButton(props.day.id, props.day.attributesMap)">Show Less</v-btn>
                </v-layout>
              </v-card-actions> -->
            </v-card>
          </drop>
        </template>
      </Calendar>
    </div>

    <!--All Tab-->
    <div v-if="displayContents('allTicket')" @click="contactId = null">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn icon color="primary" @click="addTicketItem()">
            <v-icon color="white">add</v-icon>
          </v-btn>
        <v-text-field
          v-model="allTicketSearch"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          max-width="50px"
          class="pa-3"
          clearable
          v-on:keyup.enter="
            $router.push({
              name: $route.name,
              query: {
                allTicketOffset: $route.query.allTicketOffset,
                pendingOffset: $route.query.pendingOffset,
                resolvedOffset: $route.query.resolvedOffset,
                unassignedOffset: $route.query.unassignedOffset,
                systemGeneratedOffset: $route.query.systemGeneratedOffset,
                pendingSearch: $route.query.pendingSearch,
                allTicketSearch: allTicketSearch,
                resolvedSearch: $route.query.resolvedSearch,
                unassignedSearch: $route.query.unassignedSearch,
                systemGeneratedSearch: $route.query.systemGeneratedSearch,
                records: $route.query.records,
              },
            })
          "
        ></v-text-field>
      </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
        :headers="allTicketHeaders"
        class="elevation-1"
        :rows-per-page-items="[$route.query.records]"
        :loading="isLoading"
        :items="allTicketList"
        :key="keyAllTicket"
        item-key="id"
        align-center
        style="cursor: pointer"
        hide-actions
      >
        <template v-slot:items="props">
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.currentStatus
                  .replace(/\s/g, '')
                  .toLowerCase()} white--text`"
                >{{ props.item.currentStatus }}</v-chip
              >
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">{{ props.item.id }}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">
              {{ props.item.ticketCategoryItem.ticketCategory.name }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">
              {{ props.item.ticketCategoryItem.name }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 v-if="props.item.location" class="grey--text font-weight-light">
              {{ props.item.location.locationDescription }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 v-if="props.item.location" class="grey--text font-weight-light">
              {{ props.item.location.locationNetwork.name }}
            </h3>
            <h3
              v-else-if="props.item.locationNetwork"
              class="grey--text font-weight-light"
            >
              {{ props.item.locationNetwork.name }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              class="grey--text font-weight-light"
              v-if="props.item.dueTime === null"
            >
              {{ formatDate(props.item.dueDate) }}
            </h3>
            <h3 class="grey--text font-weight-light" v-else>
              {{ formatDate(props.item.dueDate) }} {{ props.item.dueTime }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.importance
                  .replace(/\s/g, '')
                  .toLowerCase()} white--text`"
                >{{ props.item.importance }}</v-chip
              >
            </h3>
          </td>
          <td v-if="props.item.application" @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">
              {{ props.item.application.id }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)" v-else></td>
          <td v-if="props.item.device" @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">
              {{ props.item.device.ponMac }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)" v-else></td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.assignedTo !== null"
              class="grey--text font-weight-light"
            >
              {{ props.item.assignedTo.name }}
              {{ props.item.assignedTo.surname }}
            </h3>
            <h3 v-else class="grey--text font-weight-light">Unassigned</h3>
          </td>
        </template>
        <template v-slot:pageText="props"
          >Records {{ props.pageStart }} - {{ props.pageStop }} of
          {{ props.itemsLength }}</template
        >
      </v-data-table>
      <div
        class="text-xs-center pt-2 white"
        :key="$route.query.allTicketOffset"
      >
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="allTicketPage"
              :length="Math.ceil(allTicketTotalItems / $route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <!--Unassigned Tab-->
    <div v-if="displayContents('unassigned')" @click="contactId = null">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn icon color="primary" @click="addTicketItem()">
            <v-icon color="white">add</v-icon>
          </v-btn>
        <v-text-field
          v-model="unassignedSearch"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          max-width="50px"
          class="pa-3"
          clearable
          v-on:keyup.enter="
            $router.push({
              name: $route.name,
              query: {
                allTicketOffset: $route.query.allTicketOffset,
                pendingOffset: $route.query.pendingOffset,
                resolvedOffset: $route.query.resolvedOffset,
                unassignedOffset: $route.query.unassignedOffset,
                systemGeneratedOffset: $route.query.systemGeneratedOffset,
                unassignedSearch: unassignedSearch,
                pendingSearch: $route.query.pendingSearch,
                allTicketSearch: $route.query.allTicketSearch,
                resolvedSearch: $route.query.resolvedSearch,
                systemGeneratedSearch: $route.query.systemGeneratedSearch,
                records: $route.query.records,
              },
            })
          "
        ></v-text-field>
      </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        class="elevation-1"
        :rows-per-page-items="[$route.query.records]"
        :loading="isLoading"
        :items="unassignedList"
        item-key="id"
        align-center
        style="cursor: pointer"
        hide-actions
        :key="keyUnassigned"
      >
        <template v-slot:items="props">
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.currentStatus
                  .replace(/\s/g, '')
                  .toLowerCase()} white--text`"
                >{{ props.item.currentStatus }}</v-chip
              >
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">{{ props.item.id }}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">
              {{ props.item.ticketCategoryItem.ticketCategory.name }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">
              {{ props.item.ticketCategoryItem.name }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.description"
              class="longText grey--text font-weight-light"
            >
              {{ props.item.description }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 v-if="props.item.location" class="grey--text font-weight-light">
              {{ props.item.location.locationDescription }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              class="grey--text font-weight-light"
              v-if="props.item.dueTime === null"
            >
              {{ formatDate(props.item.dueDate) }}
            </h3>
            <h3 class="grey--text font-weight-light" v-else>
              {{ formatDate(props.item.dueDate) }} {{ props.item.dueTime }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.importance
                  .replace(/\s/g, '')
                  .toLowerCase()} white--text`"
                >{{ props.item.importance }}</v-chip
              >
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.createdById !== null"
              class="grey--text font-weight-light"
            >
              {{ props.item.createdBy.name }} {{ props.item.createdBy.surname }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.assignedTo !== null"
              class="grey--text font-weight-light"
            >
              {{ props.item.assignedTo.name }}
              {{ props.item.assignedTo.surname }}
            </h3>
            <h3 v-else class="grey--text font-weight-light">Unassigned</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.resolvedById !== null"
              class="grey--text font-weight-light"
            >
              {{ props.item.resolvedBy.name }}
              {{ props.item.resolvedBy.surname }}
            </h3>
          </td>
        </template>
        <template v-slot:pageText="props"
          >Records {{ props.pageStart }} - {{ props.pageStop }} of
          {{ props.itemsLength }}</template
        >
      </v-data-table>
      <div
        class="text-xs-center pt-2 white"
        :key="$route.query.unassignedOffset"
      >
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="unassignedPage"
              :length="Math.ceil(unassignedTotalItems / $route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <!--Pending Tab-->
    <div v-if="displayContents('pending')" @click="contactId = null">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn icon color="primary" @click="addTicketItem()">
            <v-icon color="white">add</v-icon>
          </v-btn>
        <v-text-field
          v-model="pendingSearch"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          max-width="50px"
          class="pa-3"
          clearable
          v-on:keyup.enter="
            $router.push({
              name: $route.name,
              query: {
                allTicketOffset: $route.query.allTicketOffset,
                pendingOffset: $route.query.pendingOffset,
                resolvedOffset: $route.query.resolvedOffset,
                unassignedOffset: $route.query.unassignedOffset,
                systemGeneratedOffset: $route.query.systemGeneratedOffset,
                pendingSearch: pendingSearch,
                allTicketSearch: $route.query.allTicketSearch,
                resolvedSearch: $route.query.resolvedSearch,
                unassignedSearch: $route.query.unassignedSearch,
                systemGeneratedSearch: $route.query.systemGeneratedSearch,
                records: $route.query.records,
              },
            })
          "
        ></v-text-field>
      </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        class="elevation-1"
        :rows-per-page-items="[$route.query.records]"
        :loading="isLoading"
        :items="pendingList"
        :key="keyPending"
        item-key="id"
        align-center
        style="cursor: pointer"
        hide-actions
      >
        <template v-slot:items="props">
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.currentStatus
                  .replace(/\s/g, '')
                  .toLowerCase()} white--text`"
                >{{ props.item.currentStatus }}</v-chip
              >
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">{{ props.item.id }}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">
              {{ props.item.ticketCategoryItem.ticketCategory.name }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">
              {{ props.item.ticketCategoryItem.name }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.description"
              class="longText grey--text font-weight-light"
            >
              {{ props.item.description }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 v-if="props.item.location" class="grey--text font-weight-light">
              {{ props.item.location.locationDescription }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              class="grey--text font-weight-light"
              v-if="props.item.dueTime === null"
            >
              {{ formatDate(props.item.dueDate) }}
            </h3>
            <h3 class="grey--text font-weight-light" v-else>
              {{ formatDate(props.item.dueDate) }} {{ props.item.dueTime }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.importance
                  .replace(/\s/g, '')
                  .toLowerCase()} white--text`"
                >{{ props.item.importance }}</v-chip
              >
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">
              {{ props.item.createdBy.name }} {{ props.item.createdBy.surname }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.assignedTo !== null"
              class="grey--text font-weight-light"
            >
              {{ props.item.assignedTo.name }}
              {{ props.item.assignedTo.surname }}
            </h3>
            <h3 v-else class="grey--text font-weight-light">Unassigned</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.resolvedById !== null"
              class="grey--text font-weight-light"
            >
              {{ props.item.resolvedBy.name }}
              {{ props.item.resolvedBy.surname }}
            </h3>
          </td>
        </template>
        <template v-slot:pageText="props"
          >Records {{ props.pageStart }} - {{ props.pageStop }} of
          {{ props.itemsLength }}</template
        >
      </v-data-table>
      <div class="text-xs-center pt-2 white" :key="$route.query.pendingOffset">
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="pendingPage"
              :length="Math.ceil(pendingTotalItems / $route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <!--Resolved Tab-->
    <div v-if="displayContents('resolved')" @click="contactId = null">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn icon color="primary" @click="addTicketItem()">
            <v-icon color="white">add</v-icon>
          </v-btn>
        <v-text-field
          v-model="resolvedSearch"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          max-width="50px"
          class="pa-3"
          clearable
          v-on:keyup.enter="
            $router.push({
              name: $route.name,
              query: {
                allTicketOffset: $route.query.allTicketOffset,
                pendingOffset: $route.query.pendingOffset,
                resolvedOffset: $route.query.resolvedOffset,
                unassignedOffset: $route.query.unassignedOffset,
                systemGeneratedOffset: $route.query.systemGeneratedOffset,
                pendingSearch: $route.query.pendingSearch,
                allTicketSearch: $route.query.allTicketSearch,
                resolvedSearch: resolvedSearch,
                unassignedSearch: $route.query.unassignedSearch,
                systemGeneratedSearch: $route.query.systemGeneratedSearch,
                records: $route.query.records,
              },
            })
          "
        ></v-text-field>
      </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        class="elevation-1"
        :rows-per-page-items="[$route.query.records]"
        :loading="isLoading"
        :key="keyResolved"
        :items="resolvedList"
        item-key="id"
        align-center
        style="cursor: pointer"
        hide-actions
        :server-items-length="resolvedTotalItems"
      >
        <template v-slot:items="props">
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.currentStatus
                  .replace(/\s/g, '')
                  .toLowerCase()} white--text`"
                >{{ props.item.currentStatus }}</v-chip
              >
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">{{ props.item.id }}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">
              {{ props.item.ticketCategoryItem.ticketCategory.name }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">
              {{ props.item.ticketCategoryItem.name }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.description"
              class="longText grey--text font-weight-light"
            >
              {{ props.item.description }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 v-if="props.item.location" class="grey--text font-weight-light">
              {{ props.item.location.locationDescription }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              class="grey--text font-weight-light"
              v-if="props.item.dueTime === null"
            >
              {{ formatDate(props.item.dueDate) }}
            </h3>
            <h3 class="grey--text font-weight-light" v-else>
              {{ formatDate(props.item.dueDate) }} {{ props.item.dueTime }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.importance
                  .replace(/\s/g, '')
                  .toLowerCase()} white--text`"
                >{{ props.item.importance }}</v-chip
              >
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">
              {{ props.item.createdBy.name }} {{ props.item.createdBy.surname }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.assignedTo !== null"
              class="grey--text font-weight-light"
            >
              {{ props.item.assignedTo.name }}
              {{ props.item.assignedTo.surname }}
            </h3>
            <h3 v-else class="grey--text font-weight-light">Unassigned</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.resolvedById !== null"
              class="grey--text font-weight-light"
            >
              {{ props.item.resolvedBy.name }}
              {{ props.item.resolvedBy.surname }}
            </h3>
          </td>
        </template>
        <template v-slot:pageText="props"
          >Records {{ props.pageStart }} - {{ props.pageStop }} of
          {{ props.itemsLength }}</template
        >
      </v-data-table>
      <div class="text-xs-center pt-2 white" :key="$route.query.resolvedOffset">
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="resolvedPage"
              :length="Math.ceil(resolvedTotalItems / $route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <!--System Generated Tab-->
    <div v-if="displayContents('systemGenerated')" @click="contactId = null">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn icon color="primary" @click="addTicketItem()">
            <v-icon color="white">add</v-icon>
          </v-btn>
        <v-text-field
          v-model="systemGeneratedSearch"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          max-width="50px"
          class="pa-3"
          clearable
          v-on:keyup.enter="
            $router.push({
              name: $route.name,
              query: {
                allTicketOffset: $route.query.allTicketOffset,
                pendingOffset: $route.query.pendingOffset,
                resolvedOffset: $route.query.resolvedOffset,
                unassignedOffset: $route.query.unassignedOffset,
                systemGeneratedOffset: $route.query.systemGeneratedOffset,
                allTicketSearch: $route.query.allTicketSearch,
                pendingSearch: $route.query.pendingSearch,
                resolvedSearch: $route.query.resolvedSearch,
                unassignedSearch: $route.query.unassignedSearch,
                systemGeneratedSearch: systemGeneratedSearch,
                records: $route.query.records,
              },
            })
          "
        ></v-text-field>
      </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        class="elevation-1"
        :rows-per-page-items="[$route.query.records]"
        :loading="isLoading"
        :items="systemGeneratedList"
        :key="keySystem"
        item-key="id"
        align-center
        style="cursor: pointer"
        hide-actions
      >
        <template v-slot:items="props">
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.currentStatus
                  .replace(/\s/g, '')
                  .toLowerCase()} white--text`"
                >{{ props.item.currentStatus }}</v-chip
              >
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">{{ props.item.id }}</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">
              {{ props.item.ticketCategoryItem.ticketCategory.name }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">
              {{ props.item.ticketCategoryItem.name }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.description"
              class="longText grey--text font-weight-light"
            >
              {{ props.item.description }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 v-if="props.item.location" class="grey--text font-weight-light">
              {{ props.item.location.locationDescription }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              class="grey--text font-weight-light"
              v-if="props.item.dueTime === null"
            >
              {{ formatDate(props.item.dueDate) }}
            </h3>
            <h3 class="grey--text font-weight-light" v-else>
              {{ formatDate(props.item.dueDate) }} {{ props.item.dueTime }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text">
              <v-chip
                small
                :class="`${props.item.importance
                  .replace(/\s/g, '')
                  .toLowerCase()} white--text`"
                >{{ props.item.importance }}</v-chip
              >
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3 class="grey--text font-weight-light">
              {{ props.item.createdBy.name }} {{ props.item.createdBy.surname }}
            </h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.assignedTo !== null"
              class="grey--text font-weight-light"
            >
              {{ props.item.assignedTo.name }}
              {{ props.item.assignedTo.surname }}
            </h3>
            <h3 v-else class="grey--text font-weight-light">Unassigned</h3>
          </td>
          <td @click="editTicket(props.item.id)">
            <h3
              v-if="props.item.resolvedById !== null"
              class="grey--text font-weight-light"
            >
              {{ props.item.resolvedBy.name }}
              {{ props.item.resolvedBy.surname }}
            </h3>
          </td>
        </template>
        <template v-slot:pageText="props"
          >Records {{ props.pageStart }} - {{ props.pageStop }} of
          {{ props.itemsLength }}</template
        >
      </v-data-table>
      <div
        class="text-xs-center pt-2 white"
        :key="$route.query.systemGeneratedOffset"
      >
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="systemGeneratedPage"
              :length="
                Math.ceil(systemGeneratedTotalItems / $route.query.records)
              "
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <!-- New Add Ticket -->
    <v-dialog v-model="viewTicket" width="1200px" persistent>
        <v-card>
            <TicketSummaryModal :ticket="ticketItem" @close="viewTicket=false, ticketItem={}" @ticketCreated="viewTicket=false,refreshTickets()" :key="ticketKey" />
        </v-card>
    </v-dialog>

    <!-- Add ticket Modal -->
    <v-dialog v-model="addTicketModal" persistent max-width="1000px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">
            ADD TICKET: {{ ticketItem.dueDate }}
          </h3>
          <v-spacer></v-spacer>

          <v-btn
            v-if="
              ticketItem.ticketCategoryId &&
              ticketItem.ticketCategoryItemId &&
              ticketItem.currentStatus &&
              ticketItem.importance &&
              ticketItem.dueDate
            "
            flat
            color="white"
            class="white--text"
            @click="createNewTicket()"
            >Save</v-btn
          >
          <v-btn v-else disabled flat>Save</v-btn>
          <v-btn
            flat
            color="white"
            class="white--text"
            @click="(addTicketModal = false), (ticketItem = {})"
            >X</v-btn
          >
        </v-toolbar>
        <v-card-text>
          <v-layout justify-center align-center>
            <v-flex>
              <v-checkbox
                label="Add from template"
                v-model="addTemplate"
              ></v-checkbox>
            </v-flex>
            <v-flex v-if="addTemplate">
              <v-autocomplete
                v-model="ticketItem.ticketTemplateId"
                :items="ticketTemplates"
                clearable
                item-text="name"
                item-value="id"
                label="Ticket Template"
                @click:clear="clearTemplate()"
                v-on:change="populateTemplate()"
              ></v-autocomplete>
            </v-flex>
            <v-flex>
              <v-checkbox
                label="Full Day Event"
                v-model="dateTimeSelect"
              ></v-checkbox>
            </v-flex>
            <v-flex>
              <VueCtkDateTimePicker
                :minDate="today"
                label="Select a Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="ticketItem.dueDate"
              />
            </v-flex>
            <v-flex>
              <VueCtkDateTimePicker
                v-if="!dateTimeSelect"
                format="HH:mm"
                formatted="HH:mm"
                minuteInterval="5"
                label="Select Time"
                only-time
                v-model="ticketItem.dueTime"
              />
            </v-flex>
          </v-layout>
          <v-layout justify-center align-center>
            <v-flex xs3 mx-2>
              <v-autocomplete
                xs6
                :items="ticketcategories"
                label="Select a Ticket Category"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2>
              <v-autocomplete
                v-if="ticketItem.ticketCategoryId"
                xs6
                :items="filteredCategoryItems"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryItemId"
              ></v-autocomplete>
              <v-autocomplete
                v-else
                xs6
                disabled
                :items="ticketcategories"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2>
              <v-select
                :items="statuses"
                label="Status"
                v-model="ticketItem.currentStatus"
              ></v-select>
            </v-flex>
            <v-flex xs3 mx-2>
              <v-select
                :items="importanceOptions"
                label="Importance"
                v-model="ticketItem.importance"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs3 mx-2>
              <v-autocomplete
                clearable
                :items="userRoles"
                label="User Role"
                item-text="name"
                item-value="id"
                v-model="ticketItem.userRoleId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2>
              <v-autocomplete
                v-if="ticketItem.userRoleId"
                v-model="ticketItem.assignedToId"
                :items="filteredUsers"
                chips
                clearable
                item-text="name"
                item-value="id"
                label="Assign Ticket to a User"
              >
                <template v-slot:selection="{ attr, on, item, selected }">
                  <v-chip
                    v-bind="attr"
                    :input-value="selected"
                    color="blue-grey"
                    class="white--text"
                    v-on="on"
                  >
                    <v-icon left>person</v-icon>
                    <span>{{ item.name }} {{ item.surname }}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <v-avatar
                    size="35px"
                    color="primary"
                    class="title font-weight-light white--text"
                    v-if="item !== 'undefined'"
                    >{{ item.name.charAt(0)
                    }}{{ item.surname.charAt(0) }}</v-avatar
                  >
                  <v-list-item-content>
                    <v-list-item-title class="grey--text ml-3"
                      >{{ item.name }} {{ item.surname }}</v-list-item-title
                    >
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-else
                disabled
                v-model="filterAssignedToId"
                :items="filteredUsers"
                chips
                clearable
                item-text="name"
                item-value="id"
                label="Assigned User"
              >
              </v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2>
              <v-select
                :items="locationTypeList"
                label="Type of Associated Location"
                v-model="locationType"
              ></v-select>
            </v-flex>
            <v-flex xs3 mx-2 v-if="locationType === 'Switching Centre'">
              <v-autocomplete
                clearable
                :items="switchingCentres"
                label="Select a Switching Centre"
                item-value="id"
                item-text="name"
                v-model="ticketItem.switchingCentreId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2 v-if="locationType === 'Location Node'">
              <v-autocomplete
                clearable
                :items="locationNodes"
                label="Select a Node"
                item-value="id"
                item-text="name"
                v-model="ticketItem.locationNodeId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2 v-if="locationType === 'Location Network'">
              <v-autocomplete
                clearable
                :items="locationNetworks"
                label="Select a Network"
                item-value="id"
                item-text="name"
                v-model="ticketItem.locationNetworkId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs2 mx-2 v-if="locationType === 'End Location'">
              <v-btn
                v-if="!ticketItem.locationId"
                round
                color="primary"
                class="white--text"
                @click="addLocationModal = true"
                >Add Location</v-btn
              >
              <v-btn
                v-else
                round
                color="primary"
                class="white--text"
                @click="addLocationModal = true"
                >Edit Location</v-btn
              >
            </v-flex>
            <v-flex
              xs4
              mx-1
              v-if="locationType === 'End Location' && ticketItem.locationId"
            >
              <h3 class="grey--text font-weight-light wrap">
                {{ ticketItem.location.locationDescription }}
              </h3>
            </v-flex>
          </v-layout>
          <v-layout justify-center align-center>
            <v-textarea
              label="Description"
              outline
              auto-grow
              v-model="ticketItem.description"
            ></v-textarea>
          </v-layout>
          <v-layout justify-center v-if="ticketAssignedLog.length > 0">
            <v-flex xs12>
              <h3 class="grey--text">Assignment Log:</h3>
            </v-flex>
            <v-flex xs12 v-for="assigned in ticketAssignedLog" :key="assigned">
              <v-layout justify-left align-center class="text-xs-left">
                <v-flex xs4>
                  <h3 class="grey--text">
                    {{ assigned.assignedBy.name }}
                    {{ assigned.assignedBy.surname }}
                  </h3>
                </v-flex>
                <v-flex xs4>
                  <h3 class="grey--text">
                    {{ assigned.assignedTo.name }}
                    {{ assigned.assignedTo.surname }}
                  </h3>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout justify-center align-center>
            <v-flex xs3>
              <h3 class="grey--text">Comments:</h3>
            </v-flex>
            <v-flex xs3>
              <v-icon color="primary" @click="addCommentBox = true"
                >add_circle_outline</v-icon
              >
            </v-flex>
          </v-layout>
          <v-flex xs12 v-if="ticketCommentLog.length === 0 && !addCommentBox">
            <h3 class="grey--text font-weight-light">No Comments</h3>
          </v-flex>
          <v-flex xs12 v-if="addCommentBox">
            <v-textarea
              label="Comment"
              outline
              auto-grow
              v-model="comment"
            ></v-textarea>
            <v-btn
              round
              color="primary"
              class="white--text"
              @click="addComment(comment)"
              >Comment</v-btn
            >
          </v-flex>
          <v-layout>
            <v-card flat style="overflow-y: auto; max-height: 1000px">
              <v-container style="text-align: left">
                <v-layout wrap>
                  <v-flex
                    xs12
                    v-for="comment in ticketCommentLog"
                    :key="comment.createdAt"
                  >
                    <v-layout justify-left align-center>
                      <v-flex xs4 mx-2>
                        <span class="grey--text font-weight-light">{{
                          formatDateTime(comment.createdAt)
                        }}</span>
                      </v-flex>
                      <v-flex xs4 mx-2>
                        <span class="grey--text font-weight-light"
                          >{{ comment.commentedBy.name }}
                          {{ comment.commentedBy.surname }}</span
                        >
                      </v-flex>
                      <v-flex xs4 mx-2>
                        <span class="grey--text font-weight-light">{{
                          comment.comment
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="filterModal" persistent max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">FILTER</h3>
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            flat
            @click="
              filterModal = false;
              clearFiltersButton();
            "
            >X</v-btn
          >
        </v-toolbar>
        <v-layout>
          <v-flex xs6 mx-2>
            <v-select
              :items="filterLocationTypeList"
              label="Associated Location"
              v-model="locationType"
              clearable
            ></v-select>
          </v-flex>
          <v-flex xs6 mx-2>
            <v-autocomplete
              v-if="
                locationType === 'End Location' ||
                typeof locationType === 'undefined'
              "
              disabled
              label="Location"
            ></v-autocomplete>
            <v-autocomplete
              v-if="locationType === 'Switching Centre'"
              clearable
              :items="switchingCentres"
              label="Switching Centre"
              item-value="id"
              item-text="name"
              v-model="filterSwitchingCentre"
            ></v-autocomplete>
            <v-autocomplete
              v-if="locationType === 'Location Node'"
              clearable
              :items="locationNodes"
              label="Node"
              item-value="id"
              item-text="name"
              v-model="filterNode"
            ></v-autocomplete>
            <v-autocomplete
              v-if="locationType === 'Location Network'"
              clearable
              :items="locationNetworks"
              label="Network"
              item-value="id"
              item-text="name"
              v-model="filterNetwork"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs6 mx-2>
            <v-select
              clearable
              :items="statuses"
              label="Status"
              v-model="filterCurrentStatus"
            ></v-select>
          </v-flex>
          <v-flex xs6 mx-2>
            <v-select
              clearable
              :items="importanceOptions"
              label="Importance"
              v-model="filterImportance"
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs6 mx-2>
            <v-autocomplete
              clearable
              xs6
              :items="ticketcategories"
              label="Ticket Category"
              item-text="name"
              item-value="id"
              v-model="filterTicketCategory"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 mx-2>
            <v-autocomplete
              clearable
              v-if="filterTicketCategory"
              :items="filteredCategoryItems"
              label="Subcategory"
              item-text="name"
              item-value="id"
              v-model="filterTicketCategoryItem"
            ></v-autocomplete>
            <v-autocomplete
              v-else
              disabled
              :items="filteredCategoryItems"
              label="Subcategory"
              item-text="name"
              item-value="id"
              v-model="filterTicketCategoryItem"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs6>
            <v-menu>
              <v-text-field
                class="text-xs-center pr-5 pl-3 pt-2"
                :value="formatDate(this.filterStartDate)"
                slot="activator"
                label="Start Date"
                prepend-icon="date_range"
              ></v-text-field>
              <v-date-picker v-model="filterStartDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6>
            <v-menu>
              <v-text-field
                class="text-xs-center pr-5 pl-3 pt-2"
                :value="formatDate(this.filterEndDate)"
                slot="activator"
                label="End Date"
                prepend-icon="date_range"
              ></v-text-field>
              <v-date-picker v-model="filterEndDate"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs6 mx-2>
            <v-autocomplete
              clearable
              :items="userRoles"
              label="User Role"
              item-text="name"
              item-value="id"
              v-model="filterUserRole"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 mx-2 v-if="displayContents('unassigned')">
            <v-autocomplete
              v-model="filterCreatedId"
              :items="filteredUsers"
              chips
              clearable
              item-text="name"
              item-value="id"
              label="Created By User"
            >
              <template v-slot:selection="{ attr, on, item, selected }">
                <v-chip
                  v-bind="attr"
                  :input-value="selected"
                  color="blue-grey"
                  class="white--text"
                  v-on="on"
                >
                  <v-icon left>person</v-icon>
                  <span>{{ item.name }} {{ item.surname }}</span>
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-avatar
                  size="35px"
                  color="primary"
                  class="title font-weight-light white--text"
                  v-if="item !== 'undefined'"
                  >{{ item.name.charAt(0)
                  }}{{ item.surname.charAt(0) }}</v-avatar
                >
                <v-list-item-content>
                  <v-list-item-title class="grey--text ml-3"
                    >{{ item.name }} {{ item.surname }}</v-list-item-title
                  >
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs6 mx-2 v-if="!displayContents('unassigned')">
            <v-autocomplete
              v-if="filterUserRole && !displayContents('unassigned')"
              v-model="filterAssignedToId"
              :items="filteredAssignedUsers"
              chips
              clearable
              item-text="name"
              item-value="id"
              label="Assigned User"
            >
              <template v-slot:selection="{ attr, on, item, selected }">
                <v-chip
                  v-bind="attr"
                  :input-value="selected"
                  color="blue-grey"
                  class="white--text"
                  v-on="on"
                >
                  <v-icon left>person</v-icon>
                  <span>{{ item.name }} {{ item.surname }}</span>
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-avatar
                  size="35px"
                  color="primary"
                  class="title font-weight-light white--text"
                  v-if="item !== 'undefined'"
                  >{{ item.name.charAt(0)
                  }}{{ item.surname.charAt(0) }}</v-avatar
                >
                <v-list-item-content>
                  <v-list-item-title class="grey--text ml-3"
                    >{{ item.name }} {{ item.surname }}</v-list-item-title
                  >
                </v-list-item-content>
              </template>
            </v-autocomplete>
            <v-autocomplete
              v-else-if="!filterUserRole && !displayContents('unassigned')"
              disabled
              v-model="filterAssignedToId"
              :items="filteredUsers"
              :filter="filterObject"
              chips
              clearable
              item-text="name"
              item-value="id"
              label="Assigned User"
            >
            </v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex
            xs6
            mx-2
            v-if="!displayContents('unassigned') && !displayContents('pending')"
          >
            <v-autocomplete
              v-model="filterResolvedId"
              :items="filteredUsers"
              chips
              clearable
              item-text="name"
              item-value="id"
              label="Resolved By User"
            >
              <template v-slot:selection="{ attr, on, item, selected }">
                <v-chip
                  v-bind="attr"
                  :input-value="selected"
                  color="blue-grey"
                  class="white--text"
                  v-on="on"
                >
                  <v-icon left>person</v-icon>
                  <span>{{ item.name }} {{ item.surname }}</span>
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-avatar
                  size="35px"
                  color="primary"
                  class="title font-weight-light white--text"
                  v-if="item !== 'undefined'"
                  >{{ item.name.charAt(0)
                  }}{{ item.surname.charAt(0) }}</v-avatar
                >
                <v-list-item-content>
                  <v-list-item-title class="grey--text ml-3"
                    >{{ item.name }} {{ item.surname }}</v-list-item-title
                  >
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs6 mx-2 v-if="!displayContents('unassigned')">
            <v-autocomplete
              v-model="filterCreatedId"
              :items="filteredUsers"
              chips
              clearable
              item-text="name"
              item-value="id"
              label="Created By User"
            >
              <template v-slot:selection="{ attr, on, item, selected }">
                <v-chip
                  v-bind="attr"
                  :input-value="selected"
                  color="blue-grey"
                  class="white--text"
                  v-on="on"
                >
                  <v-icon left>person</v-icon>
                  <span>{{ item.name }} {{ item.surname }}</span>
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-avatar
                  size="35px"
                  color="primary"
                  class="title font-weight-light white--text"
                  v-if="item !== 'undefined'"
                  >{{ item.name.charAt(0)
                  }}{{ item.surname.charAt(0) }}</v-avatar
                >
                <v-list-item-content>
                  <v-list-item-title class="grey--text ml-3"
                    >{{ item.name }} {{ item.surname }}</v-list-item-title
                  >
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
        <v-btn flat class="primary" round @click="clearFiltersButton()"
          >Clear Filters</v-btn
        >
        <v-btn flat class="primary" round @click="specifyTab()"
          >Apply Filters</v-btn
        >
      </v-card>
    </v-dialog>

    <v-dialog v-model="addLocationModal" persistent max-width="1200px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">ADD LOCATION</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="addLocationModal = false">X</v-btn>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-autocomplete
            :items="locationNetworks"
            label="Filter By Network"
            clearable
            item-value="id"
            item-text="name"
            v-model="locationFilter"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-btn icon color="primary" @click="addTicketItem()">
            <v-icon color="white">add</v-icon>
          </v-btn>
          <v-text-field
            label="Search"
            v-model="locationSearch"
            clearable
          ></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            :items="filteredLocations"
            :headers="locationHeaders"
            :search="locationSearch"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">
                <v-icon
                  @click="
                    (ticketItem.location = props.item),
                      (ticketItem.locationId = props.item.id),
                      (addLocationModal = false)
                  "
                  color="primary"
                  >add_circle_outline</v-icon
                >
              </td>
              <td class="text-xs-center">{{ props.item.unitNo }}</td>
              <td class="text-xs-center">{{ props.item.erfNo }}</td>
              <td class="text-xs-center">{{ props.item.otherNo }}</td>
              <td class="text-xs-center">{{ props.item.complexStreetName }}</td>
              <td
                class="text-xs-center"
                v-if="props.item.locationNetworkSubComplexId !== null"
              >
                {{ props.item.locationNetworkSubComplex.subcomplexName }}
              </td>
              <td v-else></td>
              <td class="text-xs-center">
                {{ props.item.locationNetwork.name }}
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api.js";
import Calendar from "v-calendar/lib/components/calendar.umd";
import dateformat from "dateformat";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { Drag, Drop } from "vue-drag-drop";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TicketCalendar from './TicketCalendar.vue'
import TicketSummaryModal from '../components/TicketSummaryModal.vue'
export default {
  props: [
    "tickets",
    "alltickets",
    "ticketcategories",
    "ticketcategoryitems",
    "users",
    "locations",
  ],
  components: {
    Calendar,
    VueCtkDateTimePicker: VueCtkDateTimePicker,
    Drag,
    Drop,
    loading: Loading,
    TicketCalendar,
    TicketSummaryModal
  },
  data() {
    return {
      loadingMore:false,
      keyCalculate: 0,
      category: true,
      categoryItemList: [],
      categoryList: [],
      searchKeys: "",
      keyComplete: null,
      allTicketList: [],
      keysList: [],
      ticketCategoryItems: [],
      keyAllTicket: 0,
      keyUnassigned: 0,
      keyPending: 0,
      keySystem: 0,
      keyResolved: 0,
      checkMoreCount: 0,
      calendarSystemGenerated: null,
      showCompletedTickets: null,
      filterModal: false,
      initialCalendar: [],
      initialAllTicket: [],
      initialSystemGenerated: [],
      initialPending: [],
      initialResolved: [],
      initialUnassigned: [],
      userRoles: [],
      filteredAssignedUsers: [],
      filterNetwork: null,
      filterNode: null,
      filterSwitchingCentre: null,
      filterCalendar: false,
      filterSystemGenerated: false,
      filterAllTicket: false,
      filterUnassigned: false,
      filterPending: false,
      filterResolved: false,
      filterUserRole: null,
      filterStartDate: null,
      filterEndDate: null,
      filterTicketCategory: null,
      filterTicketCategoryItem: null,
      filterCurrentStatus: null,
      filterImportance: null,
      filterAssignedToId: null,
      filterResolvedId: null,
      filterCreatedId: null,
      locationTypeId: null,
      locationNetworkId: null,
      locationNodeId: null,
      switchingCentreId: null,
      locationNetworks: [],
      locationNodes: [],
      switchingCentres: [],
      allTicketPage: 1,
      allTicketPagination: {},
      allTicketSearch: "",
      allTicketTotalItems: 0,
      systemGeneratedPage: 1,
      systemGeneratedPagination: {},
      systemGeneratedSearch: "",
      systemGeneratedTotalItems: 0,
      pendingPage: 1,
      pendingPagination: {},
      pendingSearch: "",
      pendingTotalItems: 0,
      resolvedPage: 1,
      resolvedPagination: {},
      resolvedSearch: "",
      resolvedTotalItems: 0,
      unassignedPage: 1,
      unassignedPagination: {},
      unassignedSearch: "",
      unassignedTotalItems: 0,
      loadingTicket: false,
      systemGeneratedList: [],
      resolvedList: [],
      pendingList: [],
      unassignedList: [],
      addTemplate: false,
      ticketTemplates: [],
      isLoading: false,
      customData: {},
      showMore: false,
      viewTicket: false,
      allTicketHeaders: [
        {
          text: "Status",
          align: "center",
          value: "currentStatus",
          sortable: false,
        },
        {
          text: "Ticket ID",
          align: "center",
          value: "id",
          sortable: false,
        },
        {
          text: "Category",
          align: "center",
          value: "ticketCategoryItem.ticketCategory.name",
          sortable: false,
        },
        {
          text: "Subcategory",
          align: "center",
          value: "ticketCategoryItem.name",
          sortable: false,
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription",
          sortable: false,
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name",
          sortable: false,
        },
        {
          text: "Due",
          align: "center",
          value: "dueDate",
          sortable: false,
        },
        {
          text: "Priority",
          align: "center",
          value: "importance",
          sortable: false,
        },
        {
          text: "Order ID",
          align: "center",
          value: "application.id",
          sortable: false,
        },
        {
          text: "Device",
          align: "center",
          value: "device.ponMac",
          sortable: false,
        },
        {
          text: "Assigned To",
          align: "center",
          value: "assignedTo.name",
          sortable: false,
        },
      ],
      headers: [
        {
          text: "Status",
          align: "center",
          value: "currentStatus",
          sortable: false,
        },
        {
          text: "Ticket ID",
          align: "center",
          value: "id",
          sortable: false,
        },
        {
          text: "Category",
          align: "center",
          value: "ticketCategoryItem.ticketCategory.name",
          sortable: false,
        },
        {
          text: "Subcategory",
          align: "center",
          value: "ticketCategoryItem.name",
          sortable: false,
        },
        {
          text: "Description",
          align: "center",
          value: "description",
          sortable: false,
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription",
          sortable: false,
        },
        {
          text: "Due",
          align: "center",
          value: "dueDate",
          sortable: false,
        },
        {
          text: "Priority",
          align: "center",
          value: "importance",
          sortable: false,
        },
        {
          text: "Created By",
          align: "center",
          value: "createdBy.name",
          sortable: false,
        },
        {
          text: "Assigned To",
          align: "center",
          value: "assignedTo.name",
          sortable: false,
        },
        {
          text: "Resolved By",
          align: "center",
          value: "resolvedBy.name",
          sortable: false,
        },
      ],
      search: "",
      newDay: this.formatDate(new Date()),
      contactTableId: null,
      contacts: [],
      contactId: null,
      cardsPerPage: 2,
      resultCount: 0,
      currentPage: 1,
      activeTabName: "",
      key: 0,
      addTicketModal: false,
      editTicketModal: false,
      datePicker: false,
      timePicker: false,
      dateTimeSelect: true,
      addLocationModal: false,
      over: false,
      ticketItem: {},
      filteredCategoryItems: [],
      filteredUsers: [],
      ticketAssignedLog: [],
      ticketCommentLog: [],
      filteredLocations: [],
      filteredTickets: [],
      allFilteredTickets: [],
      locationFilter: null,
      userSearch: "",
      comment: "",
      locationSearch: "",
      overData: null,
      initialAssignedId: null,
      filterLocationTypeList: [
        "Location Network",
        "Location Node",
        "Switching Centre",
      ],
      locationTypeList: [
        "End Location",
        "Location Network",
        "Location Node",
        "Switching Centre",
      ],
      locationType: "",
      tributeOptions: { lookup: "name", values: this.users },
      addCommentBox: false,
      statuses: ["Incomplete", "Pending", "In Progress", "Complete"],
      importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
      today: this.formatDate(new Date()),
      tabs: [
        { name: "calendar", displayName: "Calendar" },
        { name: "allTicket", displayName: "All Tickets" },
        { name: "unassigned", displayName: "Unassigned" },
        { name: "pending", displayName: "Pending" },
        { name: "resolved", displayName: "Resolved" },
        { name: "systemGenerated", displayName: "System Generated" },
      ],
      locationHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Unit No",
          align: "center",
          value: "unitNo",
        },
        {
          text: "Erf No",
          align: "center",
          value: "erfNo",
        },
        {
          text: "Other No",
          align: "center",
          value: "otherNo",
        },
        {
          text: "Street Name",
          align: "center",
          value: "complexStreetName",
        },
        {
          text: "Sub Complex",
          align: "center",
          value: "locationNetworkSubComplex.subcomplexName",
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name",
        },
      ],
    };
  },
  watch: {
    async searchKeys(value) {
      if (
        typeof value === "undefined" ||
        value === null ||
        value.length === 0 ||
        value === ""
      ) {
        this.categoryItemList = this.categoryList;
        //this.category = true
      } else {
        await Api()
          .get("/ticketCategory/keys/search", {
            params: {
              search: value,
            },
          })
          .then(async (response) => {
            this.categoryItemList = response.data;
            //this.category = false
          });
      }
    },
    showCompletedTickets(value) {
      if (value) {
        let dates = [...new Set(this.allFilteredTickets.map((x) => x.dates))];

        let result = [];
        for (let i = 0; i < dates.length; i++) {
          let sliceData = this.allFilteredTickets
            .filter(
              (x) =>
                x.customData.isSystemGenerated ===
                  this.calendarSystemGenerated &&
                x.customData.isComplete &&
                x.dates === dates[i]
            )
            .slice(0, 3);
          result = [...result, ...sliceData];
        }
        this.filteredTickets = result;
        this.filterTicketCategory = null;
        this.filterTicketCategoryItem = null;
        this.keyComplete = null;
      } else {
        let dates = [...new Set(this.allFilteredTickets.map((x) => x.dates))];

        let result = [];
        for (let i = 0; i < dates.length; i++) {
          let sliceData = this.allFilteredTickets
            .filter(
              (x) =>
                x.customData.isSystemGenerated ===
                  this.calendarSystemGenerated &&
                !x.customData.isComplete &&
                x.dates === dates[i]
            )
            .slice(0, 3);
          result = [...result, ...sliceData];
        }
        this.filteredTickets = result;
      }
    },
    calendarSystemGenerated(value) {
      if (value === true) {
        let dates = [...new Set(this.allFilteredTickets.map((x) => x.dates))];

        let result = [];
        for (let i = 0; i < dates.length; i++) {
          let sliceData = this.allFilteredTickets
            .filter(
              (x) =>
                x.customData.isComplete === this.showCompletedTickets &&
                x.customData.isSystemGenerated &&
                x.dates === dates[i]
            )
            .slice(0, 3);
          result = [...result, ...sliceData];
        }
        this.filteredTickets = result;
        this.filterTicketCategory = null;
        this.filterTicketCategoryItem = null;
        this.keyComplete = null;
        this.key++;
      } else {
        let dates = [...new Set(this.allFilteredTickets.map((x) => x.dates))];

        let result = [];
        for (let i = 0; i < dates.length; i++) {
          let sliceData = this.allFilteredTickets
            .filter(
              (x) =>
                x.customData.isComplete === this.showCompletedTickets &&
                !x.customData.isSystemGenerated &&
                x.dates === dates[i]
            )
            .slice(0, 3);
          result = [...result, ...sliceData];
        }
        this.filteredTickets = result;
        this.key++;
      }
    },
    showMore(value) {
      // if(!value){
      //   let dates = [...new Set(this.allFilteredTickets.map(x=>x.dates))]
      //   this.filteredTickets= []
      //   let result = []
      //   for(let i=0; i<dates.length;i++){
      //     let sliceData = this.allFilteredTickets.filter(x=>x.dates===dates[i]).slice(0,3)
      //   result = [...result, ...sliceData]
      //   }
      //   this.filteredTickets = result
      // } else {
      //   this.filteredTickets = this.allFilteredTickets
      // }
    },
    locationType(value) {
      this.ticketItem.locationId = null;
      this.ticketItem.locationNetworkId = null;
      this.ticketItem.locationNodeId = null;
      this.ticketItem.switchingCentreId = null;
      this.ticketItem.location = {};
    },
    "ticketItem.ticketTemplateId": {
      immediate: true,
      async handler(value) {
        if (value === null && this.ticketItem.ticketCategoryId != null) {
          Api()
            .get(
              "/ticketCategoryItem/byCategory/" +
                this.ticketItem.ticketCategoryId
            )
            .then((response) => {
              for (let k = 0; k < response.length; k++) {
                this.filteredCategoryItems = response.data[k];
              }
            });
        }
      },
    },
    "ticketItem.userRoleId": {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          Api()
            .get("/userRoleContact/byUserRole/" + value)
            .then((response) => {
              this.filteredUsers = response.data.map((x) => x.contact);
            });
        }
      },
    },
    filterUserRole: {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          Api()
            .get("/userRoleContact/byUserRole/" + value)
            .then((response) => {
              this.filteredAssignedUsers = response.data.map((x) => x.contact);
            });
        } else {
          this.filteredAssignedUsers = this.filteredUsers;
        }
      },
    },
    filterTicketCategory: {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          this.filteredCategoryItems = await this.ticketcategoryitems.filter(
            function (el) {
              return el.ticketCategoryId === value;
            }
          );
        } else {
          this.filteredCategoryItems = this.ticketcategoryitems;
        }
      },
    },
    "ticketItem.ticketCategoryId": {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          this.filteredCategoryItems = await this.ticketcategoryitems.filter(
            function (el) {
              return el.ticketCategoryId === value;
            }
          );
        } else {
          this.filteredCategoryItems = this.ticketcategoryitems;
        }
      },
    },
    locationFilter(value) {
      if (value !== null && typeof value !== "undefined") {
        this.filteredLocations = this.locations.filter(function (el) {
          return el.locationNetworkId === value;
        });
      } else {
        this.filteredLocations = this.locations;
      }
    },
    users(value) {
      if (value.length > 0) {
        this.filteredUsers = this.users;
      }
    },
    locations(value) {
      if (value.length > 0) {
        this.filteredLocations = this.locations;
      }
    },
    ticketcategoryitems(value) {
      if (value.length > 0) {
        this.filteredCategoryItems = this.ticketcategoryitems;
      }
    },
    "ticketItem.assignedToId": {
      immediate: true,
      handler(value) {
        if (this.editTicketModal && value !== this.initialAssignedId) {
          if (
            this.ticketItem.id &&
            value !== null &&
            typeof value !== "undefined"
          ) {
            Api()
              .post("/ticketAssignLog", {
                ticketId: this.ticketItem.id,
                assignedToId: this.ticketItem.assignedToId,
              })
              .then((response) => {
                let find = this.users.find((x) => x.id === value);
                response.data.assignedTo = find;
                response.data.assignedBy = this.$store.state.user;
                this.ticketAssignedLog.push(response.data);
              });
            Api().put("/ticket/" + this.ticketItem.id, {
              assignedToId: this.ticketItem.assignedToId,
            });
          }
        }
      },
    },

    "$route.query.allTicketSearch": {
      immediate: true,
      handler(value) {
        if (
          this.$route.query.allTicketSearch &&
          value !== "" &&
          value != null
        ) {
          this.allTicketPage = 1;
          Api()
            .get("/ticket/all", {
              params: {
                search: this.$route.query.allTicketSearch,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.allTicketList = response.data.result;
              this.allTicketTotalItems = response.data.count;
              this.keyAllTicket++;
            });
        } else if (this.$route.query.allTicketOffset) {
          Api()
            .get("/ticket/all", {
              params: {
                offset: this.$route.query.allTicketOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.allTicketList = response.data.result;
              this.allTicketTotalItems = response.data.count;
              this.keyAllTicket++;
            });
        }
      },
    },
    "$route.query.allTicketOffset": {
      immediate: true,
      handler(value) {
        if (
          value !== "" &&
          value != null &&
          this.$route.query.allTicketSearch &&
          this.$route.query.allTicketSearch != "" &&
          this.$route.query.allTicketSearch !== null
        ) {
          Api()
            .get("/ticket/all", {
              params: {
                search: this.$route.query.allTicketSearch,
                offset: this.$route.query.allTicketOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.allTicketList = response.data.result;
              this.allTicketTotalItems = response.data.count;
              this.keyAllTicket++;
            });
        } else if (value != null) {
          Api()
            .get("/ticket/all", {
              params: {
                offset: this.$route.query.allTicketOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.allTicketList = response.data.result;
              this.allTicketTotalItems = response.data.count;
              this.keyAllTicket++;
            });
        }
      },
    },
    allTicketPage(value) {
      this.allTicketPagination.page = this.allTicketPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.allTicketSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              resolvedOffset: this.$route.query.resolvedOffset,
              unassignedOffset: this.$route.query.unassignedOffset,
              systemGeneratedOffset: this.$route.query.systemGeneratedOffset,
              allTicketOffset: (value - 1) * this.$route.query.records,
              resolvedSearch: this.$route.query.resolvedSearch,
              pendingSearch: this.$route.query.pendingSearch,
              allTicketSearch: this.$route.query.allTicketSearch,
              unassignedSearch: this.$route.query.unassignedSearch,
              systemGeneratedSearch: this.$route.query.systemGeneratedSearch,
            },
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              resolvedOffset: this.$route.query.resolvedOffset,
              allTicketOffset: (value - 1) * this.$route.query.records,
              unassignedOffset: this.$route.query.unassignedOffset,
              systemGeneratedOffset: this.$route.query.systemGeneratedOffset,
              resolvedSearch: this.$route.query.resolvedSearch,
              pendingSearch: this.$route.query.pendingSearch,
              unassignedSearch: this.$route.query.unassignedSearch,
              systemGeneratedSearch: this.$route.query.systemGeneratedSearch,
            },
          });
        }
      }
    },

    // Pending Applications
    "$route.query.pendingSearch": {
      immediate: true,
      handler(value) {
        if (this.$route.query.pendingSearch && value !== "" && value != null) {
          this.pendingPage = 1;
          Api()
            .get("/ticket/active", {
              params: {
                search: this.$route.query.pendingSearch,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.pendingList = response.data.result;
              this.pendingTotalItems = response.data.count;
              this.keyPending++;
            });
        } else if (this.$route.query.pendingOffset) {
          Api()
            .get("/ticket/active", {
              params: {
                offset: this.$route.query.pendingOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.pendingList = response.data.result;
              this.pendingTotalItems = response.data.count;
              this.keyPending++;
            });
        }
      },
    },
    "$route.query.pendingOffset": {
      immediate: true,
      handler(value) {
        if (
          value !== "" &&
          value != null &&
          this.$route.query.pendingSearch &&
          this.$route.query.pendingSearch != "" &&
          this.$route.query.pendingSearch !== null
        ) {
          Api()
            .get("/ticket/active", {
              params: {
                search: this.$route.query.pendingSearch,
                offset: this.$route.query.pendingOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.pendingList = response.data.result;
              this.pendingTotalItems = response.data.count;
              this.keyPending++;
            });
        } else if (value != null) {
          Api()
            .get("/ticket/active", {
              params: {
                offset: this.$route.query.pendingOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.pendingList = response.data.result;
              this.pendingTotalItems = response.data.count;
              this.keyPending++;
            });
        }
      },
    },
    pendingPage(value) {
      this.pendingPagination.page = this.pendingPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.pendingSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: this.$route.query.resolvedOffset,
              unassignedOffset: this.$route.query.unassignedOffset,
              systemGeneratedOffset: this.$route.query.systemGeneratedOffset,
              pendingOffset: (value - 1) * this.$route.query.records,
              resolvedSearch: this.$route.query.resolvedSearch,
              pendingSearch: this.$route.query.pendingSearch,
              unassignedSearch: this.$route.query.unassignedSearch,
              systemGeneratedSearch: this.$route.query.systemGeneratedSearch,
              allTicketOffset: this.$route.query.allTicketOffset,
              allTicketSearch: this.$route.query.allTicketSearch,
            },
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: this.$route.query.resolvedOffset,
              pendingOffset: (value - 1) * this.$route.query.records,
              unassignedOffset: this.$route.query.unassignedOffset,
              systemGeneratedOffset: this.$route.query.systemGeneratedOffset,
              resolvedSearch: this.$route.query.resolvedSearch,
              unassignedSearch: this.$route.query.unassignedSearch,
              systemGeneratedSearch: this.$route.query.systemGeneratedSearch,
              allTicketOffset: this.$route.query.allTicketOffset,
              allTicketSearch: this.$route.query.allTicketSearch,
            },
          });
        }
      }
    },

    // Resolved
    "$route.query.resolvedSearch": {
      immediate: true,
      handler(value) {
        if (this.$route.query.resolvedSearch && value !== "" && value != null) {
          this.resolvedPage = 1;
          Api()
            .get("/ticket/resolved", {
              params: {
                search: this.$route.query.resolvedSearch,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.resolvedList = response.data.result;
              this.resolvedTotalItems = response.data.count;
              this.keyResolved++;
            });
        } else if (this.$route.query.resolvedOffset) {
          Api()
            .get("/ticket/resolved", {
              params: {
                offset: this.$route.query.resolvedOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.resolvedList = response.data.result;
              this.resolvedTotalItems = response.data.count;
              this.keyResolved++;
            });
        }
      },
    },
    "$route.query.resolvedOffset": {
      immediate: true,
      handler(value) {
        if (
          value !== "" &&
          value != null &&
          this.$route.query.resolvedSearch &&
          this.$route.query.resolvedSearch != "" &&
          this.$route.query.resolvedSearch !== null
        ) {
          Api()
            .get("/ticket/resolved", {
              params: {
                search: this.$route.query.resolvedSearch,
                offset: this.$route.query.resolvedOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.resolvedList = response.data.result;
              this.resolvedTotalItems = response.data.count;
              this.keyResolved++;
            });
        } else if (value != null) {
          Api()
            .get("/ticket/resolved", {
              params: {
                offset: this.$route.query.resolvedOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.resolvedList = response.data.result;
              this.resolvedTotalItems = response.data.count;
              this.keyResolved++;
            });
        }
      },
    },
    resolvedPage(value) {
      this.resolvedPagination.page = this.resolvedPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.resolvedSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              unassignedOffset: this.$route.query.unassignedOffset,
              systemGeneratedOffset: this.$route.query.systemGeneratedOffset,
              resolvedSearch: this.$route.query.resolvedSearch,
              pendingSearch: this.$route.query.pendingSearch,
              unassignedSearch: this.$route.query.unassignedSearch,
              systemGeneratedSearch: this.$route.query.systemGeneratedSearch,
              allTicketOffset: this.$route.query.allTicketOffset,
              allTicketSearch: this.$route.query.allTicketSearch,
            },
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              unassignedOffset: this.$route.query.unassignedOffset,
              systemGeneratedOffset: this.$route.query.systemGeneratedOffset,
              pendingSearch: this.$route.query.pendingSearch,
              unassignedSearch: this.$route.query.unassignedSearch,
              systemGeneratedSearch: this.$route.query.systemGeneratedSearch,
              allTicketOffset: this.$route.query.allTicketOffset,
              allTicketSearch: this.$route.query.allTicketSearch,
            },
          });
        }
      }
    },
    // Unassigned
    "$route.query.unassignedSearch": {
      immediate: true,
      handler(value) {
        if (
          this.$route.query.unassignedSearch &&
          value !== "" &&
          value != null
        ) {
          this.unassignedPage = 1;
          Api()
            .get("/ticket/unassigned", {
              params: {
                search: this.$route.query.unassignedSearch,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.unassignedList = response.data.result;
              this.unassignedTotalItems = response.data.count;
              this.keyUnassigned++;
            });
        } else if (this.$route.query.unassignedOffset) {
          Api()
            .get("/ticket/unassigned", {
              params: {
                offset: this.$route.query.unassignedOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.unassignedList = response.data.result;
              this.unassignedTotalItems = response.data.count;
              this.keyUnassigned++;
            });
        }
      },
    },
    "$route.query.unassignedOffset": {
      immediate: true,
      handler(value) {
        if (
          value !== "" &&
          value != null &&
          this.$route.query.unassignedSearch &&
          this.$route.query.unassignedSearch != "" &&
          this.$route.query.unassignedSearch !== null
        ) {
          Api()
            .get("/ticket/unassigned", {
              params: {
                search: this.$route.query.unassignedSearch,
                offset: this.$route.query.unassignedOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.unassignedList = response.data.result;
              this.unassignedTotalItems = response.data.count;
              this.keyUnassigned++;
            });
        } else if (value != null) {
          Api()
            .get("/ticket/unassigned", {
              params: {
                offset: this.$route.query.unassignedOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.unassignedList = response.data.result;
              this.unassignedTotalItems = response.data.count;
              this.keyUnassigned++;
            });
        }
      },
    },
    unassignedPage(value) {
      this.unassignedPagination.page = this.unassignedPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.unassignedSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              unassignedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              resolvedOffset: this.$route.query.resolvedOffset,
              systemGeneratedOffset: this.$route.query.systemGeneratedOffset,
              resolvedSearch: this.$route.query.resolvedSearch,
              pendingSearch: this.$route.query.pendingSearch,
              unassignedSearch: this.$route.query.unassignedSearch,
              systemGeneratedSearch: this.$route.query.systemGeneratedSearch,
              allTicketOffset: this.$route.query.allTicketOffset,
              allTicketSearch: this.$route.query.allTicketSearch,
            },
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              unassignedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              resolvedOffset: this.$route.query.resolvedOffset,
              systemGeneratedOffset: this.$route.query.systemGeneratedOffset,
              pendingSearch: this.$route.query.pendingSearch,
              resolvedSearch: this.$route.query.resolvedSearch,
              systemGeneratedSearch: this.$route.query.systemGeneratedSearch,
              allTicketOffset: this.$route.query.allTicketOffset,
              allTicketSearch: this.$route.query.allTicketSearch,
            },
          });
        }
      }
    },
    // System Generated
    "$route.query.systemGeneratedSearch": {
      immediate: true,
      handler(value) {
        if (
          this.$route.query.systemGeneratedSearch &&
          value !== "" &&
          value != null
        ) {
          this.systemGeneratedPage = 1;
          Api()
            .get("/ticket/systemGenerated", {
              params: {
                search: this.$route.query.systemGeneratedSearch,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.systemGeneratedList = response.data.result;
              this.systemGeneratedTotalItems = response.data.count;
              this.keySystem++;
            });
        } else if (this.$route.query.systemGeneratedOffset) {
          Api()
            .get("/ticket/systemGenerated", {
              params: {
                offset: this.$route.query.systemGeneratedOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.systemGeneratedList = response.data.result;
              this.systemGeneratedTotalItems = response.data.count;
              this.keySystem++;
            });
        }
      },
    },
    "$route.query.systemGeneratedOffset": {
      immediate: true,
      handler(value) {
        if (
          value !== "" &&
          value != null &&
          this.$route.query.systemGeneratedSearch &&
          this.$route.query.systemGeneratedSearch != "" &&
          this.$route.query.systemGeneratedSearch !== null
        ) {
          Api()
            .get("/ticket/systemGenerated", {
              params: {
                search: this.$route.query.systemGeneratedSearch,
                offset: this.$route.query.systemGeneratedOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.systemGeneratedList = response.data.result;
              this.systemGeneratedTotalItems = response.data.count;
              this.keySystem++;
            });
        } else if (value != null) {
          Api()
            .get("/ticket/systemGenerated", {
              params: {
                offset: this.$route.query.systemGeneratedOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.systemGeneratedList = response.data.result;
              this.systemGeneratedTotalItems = response.data.count;
              this.keySystem++;
            });
        }
      },
    },
    systemGeneratedPage(value) {
      this.systemGeneratedPagination.page = this.systemGeneratedPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.systemGeneratedSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              systemGeneratedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              resolvedOffset: this.$route.query.resolvedOffset,
              unassignedOffset: this.$route.query.unassignedOffset,
              resolvedSearch: this.$route.query.resolvedSearch,
              pendingSearch: this.$route.query.pendingSearch,
              unassignedSearch: this.$route.query.unassignedSearch,
              systemGeneratedSearch: this.$route.query.systemGeneratedSearch,
              allTicketOffset: this.$route.query.allTicketOffset,
              allTicketSearch: this.$route.query.allTicketSearch,
            },
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              systemGeneratedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              resolvedOffset: this.$route.query.resolvedOffset,
              unassignedOffset: this.$route.query.unassignedOffset,
              pendingSearch: this.$route.query.pendingSearch,
              resolvedSearch: this.$route.query.resolvedSearch,
              unassignedSearch: this.$route.query.unassignedSearch,
              allTicketOffset: this.$route.query.allTicketOffset,
              allTicketSearch: this.$route.query.allTicketSearch,
            },
          });
        }
      }
    },
    filterAllTicket(value) {
      const route = {
        name: this.$route.name,
      };
      if (value === true) {
        route.query = {
          currentTab: "allTicket",
          currentStatus: this.filterCurrentStatus,
          importance: this.filterImportance,
          category: this.filterTicketCategory,
          categoryItem: this.filterTicketCategoryItem,
          userRole: this.filterUserRole,
          assigned: this.filterAssignedToId,
          created: this.filterCreatedId,
          startDate: this.filterStartDate,
          endDate: this.filterEndDate,
          locationNetwork: this.filterNetwork,
          locationNode: this.filterNode,
          switchingCentre: this.filterSwitchingCentre,
          offset: "0",
          records: this.$route.query.records,
        };
        this.$router.push(route);
        this.filterModal = false;
        this.filterAllTicket = false;
      }
    },
    filterUnassigned(value) {
      const route = {
        name: this.$route.name,
      };
      if (value === true) {
        route.query = {
          currentTab: "unassigned",
          currentStatus: this.filterCurrentStatus,
          importance: this.filterImportance,
          category: this.filterTicketCategory,
          categoryItem: this.filterTicketCategoryItem,
          userRole: this.filterUserRole,
          assigned: this.filterAssignedToId,
          created: this.filterCreatedId,
          startDate: this.filterStartDate,
          endDate: this.filterEndDate,
          locationNetwork: this.filterNetwork,
          locationNode: this.filterNode,
          switchingCentre: this.filterSwitchingCentre,
          offset: "0",
          records: this.$route.query.records,
        };
        this.$router.push(route);
        this.filterModal = false;
        this.filterUnassigned = false;
      }
    },
    filterPending(value) {
      const route = {
        name: this.$route.name,
      };
      if (value === true) {
        route.query = {
          currentTab: "pending",
          currentStatus: this.filterCurrentStatus,
          importance: this.filterImportance,
          category: this.filterTicketCategory,
          categoryItem: this.filterTicketCategoryItem,
          userRole: this.filterUserRole,
          assigned: this.filterAssignedToId,
          created: this.filterCreatedId,
          startDate: this.filterStartDate,
          endDate: this.filterEndDate,
          locationNetwork: this.filterNetwork,
          locationNode: this.filterNode,
          switchingCentre: this.filterSwitchingCentre,
          offset: "0",
          records: this.$route.query.records,
        };
        this.$router.push(route);
        this.filterModal = false;
        this.filterPending = false;
      }
    },
    filterResolved(value) {
      const route = {
        name: this.$route.name,
      };
      if (value === true) {
        route.query = {
          currentTab: "resolved",
          currentStatus: this.filterCurrentStatus,
          importance: this.filterImportance,
          category: this.filterTicketCategory,
          categoryItem: this.filterTicketCategoryItem,
          userRole: this.filterUserRole,
          resolved: this.filterResolvedId,
          created: this.filterCreatedId,
          assigned: this.filterAssignedToId,
          startDate: this.filterStartDate,
          endDate: this.filterEndDate,
          locationNetwork: this.filterNetwork,
          locationNode: this.filterNode,
          switchingCentre: this.filterSwitchingCentre,
          offset: "0",
          records: this.$route.query.records,
        };
        this.$router.push(route);
        this.filterModal = false;
        this.filterResolved = false;
      }
    },
    filterSystemGenerated(value) {
      const route = {
        name: this.$route.name,
      };
      if (value === true) {
        route.query = {
          currentTab: "systemGenerated",
          currentStatus: this.filterCurrentStatus,
          importance: this.filterImportance,
          category: this.filterTicketCategory,
          categoryItem: this.filterTicketCategoryItem,
          userRole: this.filterUserRole,
          assigned: this.filterAssignedToId,
          resolved: this.filterResolvedId,
          created: this.filterCreatedId,
          startDate: this.filterStartDate,
          endDate: this.filterEndDate,
          locationNetwork: this.filterNetwork,
          locationNode: this.filterNode,
          switchingCentre: this.filterSwitchingCentre,
          offset: "0",
          records: this.$route.query.records,
        };
        this.$router.push(route);
        this.filterModal = false;
        this.filterSystemGenerated = false;
      }
    },
    filterCalendar(value) {
      const route = {
        name: this.$route.name,
      };
      if (value === true) {
        route.query = {
          currentTab: "calendar",
          currentStatus: this.filterCurrentStatus,
          importance: this.filterImportance,
          category: this.filterTicketCategory,
          categoryItem: this.filterTicketCategoryItem,
          userRole: this.filterUserRole,
          assigned: this.filterAssignedToId,
          resolved: this.filterResolvedId,
          created: this.filterCreatedId,
          startDate: this.filterStartDate,
          endDate: this.filterEndDate,
          locationNetwork: this.filterNetwork,
          locationNode: this.filterNode,
          switchingCentre: this.filterSwitchingCentre,
          offset: "0",
          records: this.$route.query.records,
        };
        this.$router.push(route);
        this.filterModal = false;

        this.filterCalendar = false;
      }
    },
    "$route.query": {
      immediate: true,
      async handler(value) {
        // this.pendingPage = 1;
        // this.resolvedPage = 1;
        // this.unassignedPage = 1;
        // this.systemGeneratedPage = 1;
        if (typeof value.currentStatus === "undefined") {
          value.currentStatus = null;
        }
        if (typeof value.importance === "undefined") {
          value.importance = null;
        }
        if (typeof value.currentStatus === "undefined") {
          value.currentStatus = null;
        }
        if (typeof value.importance === "undefined") {
          value.importance = null;
        }
        if (typeof value.category === "undefined") {
          value.category = null;
        }
        if (typeof value.categoryItem === "undefined") {
          value.categoryItem = null;
        }
        if (typeof value.userRole === "undefined") {
          value.userRole = null;
        }
        if (typeof value.assigned === "undefined") {
          value.assigned = null;
        }
        if (typeof value.resolved === "undefined") {
          value.resolved = null;
        }
        if (typeof value.created === "undefined") {
          value.created = null;
        }
        if (typeof value.startDate === "undefined") {
          value.startDate = null;
        }
        if (typeof value.endDate === "undefined") {
          value.endDate = null;
        }
        if (typeof value.locationNetwork === "undefined") {
          value.locationNetwork = null;
        }
        if (typeof value.locationNode === "undefined") {
          value.locationNode = null;
        }
        if (typeof value.switchingCentre === "undefined") {
          value.switchingCentre = null;
        }

        let currentStatus = value.currentStatus;
        let importance = value.importance;
        let category = value.category;
        let categoryItem = value.categoryItem;
        let userRole = value.userRole;
        let assigned = value.assigned;
        let resolved = value.resolved;
        let created = value.created;
        let startDate = value.startDate;
        let endDate = value.endDate;
        let locationNetwork = value.locationNetwork;
        let locationNode = value.locationNode;
        let switchingCentre = value.switchingCentre;

        if (value.currentTab === "unassigned") {
          this.unassignedList = this.initialUnassigned;

          if (currentStatus !== null) {
            this.unassignedList = await this.unassignedList.filter(function (
              el
            ) {
              return el.currentStatus === currentStatus;
            });
          }
          if (importance !== null) {
            this.unassignedList = await this.unassignedList.filter(function (
              el
            ) {
              return el.importance === importance;
            });
          }
          if (category !== null && categoryItem !== null) {
            this.unassignedList = await this.unassignedList.filter(function (
              el
            ) {
              return el.ticketCategoryItemId === categoryItem;
            });
          } else if (category !== null && categoryItem === null) {
            this.unassignedList = await this.unassignedList.filter(function (
              el
            ) {
              return el.ticketCategoryItem.ticketCategoryId === category;
            });
          }
          if (userRole !== null && assigned !== null) {
            this.unassignedList = await this.unassignedList.filter(function (
              el
            ) {
              return el.assignedToId === assigned;
            });
          } else if (userRole !== null && assigned === null) {
            this.unassignedList = await this.unassignedList.filter(function (
              el
            ) {
              return el.userRoleId === userRole;
            });
          }
          if (startDate !== null) {
            this.unassignedList = await this.unassignedList.filter(function (
              el
            ) {
              return el.dueDate >= startDate;
            });
          }
          if (endDate !== null) {
            var date = new Date(endDate);
            var day = 60 * 60 * 24 * 1000;
            var end = this.formatDate(new Date(date.getTime() + day));
            this.unassignedList = await this.unassignedList.filter(function (
              el
            ) {
              return el.dueDate <= end;
            });
          }
          if (locationNetwork !== null) {
            this.unassignedList = await this.unassignedList.filter(function (
              el
            ) {
              return el.locationNetworkId === locationNetwork;
            });
          }
          if (locationNode !== null) {
            this.unassignedList = await this.unassignedList.filter(function (
              el
            ) {
              return el.locationNodeId === locationNode;
            });
          }
          if (switchingCentre !== null) {
            this.unassignedList = await this.unassignedList.filter(function (
              el
            ) {
              return el.switchingCentreId === switchingCentre;
            });
          }
          if (created !== null) {
            this.unassignedList = await this.unassignedList.filter(function (
              el
            ) {
              return el.createdById === created;
            });
          }
          this.unassignedTotalItems = this.unassignedList.length;
          this.keyUnassigned++;
        }

        if (value.currentTab === "pending") {
          this.pendingList = this.initialPending;

          if (currentStatus !== null) {
            this.pendingList = await this.pendingList.filter(function (el) {
              return el.currentStatus === currentStatus;
            });
          }
          if (importance !== null) {
            this.pendingList = await this.pendingList.filter(function (el) {
              return el.importance === importance;
            });
          }
          if (category !== null && categoryItem !== null) {
            this.pendingList = await this.pendingList.filter(function (el) {
              return el.ticketCategoryItemId === categoryItem;
            });
          } else if (category !== null && categoryItem === null) {
            this.pendingList = await this.pendingList.filter(function (el) {
              return el.ticketCategoryItem.ticketCategoryId === category;
            });
          }
          if (userRole !== null && assigned !== null) {
            this.pendingList = await this.pendingList.filter(function (el) {
              return el.assignedToId === assigned;
            });
          } else if (userRole !== null && assigned === null) {
            this.pendingList = await this.pendingList.filter(function (el) {
              return el.userRoleId === userRole;
            });
          }
          if (startDate !== null) {
            this.pendingList = await this.pendingList.filter(function (el) {
              return el.dueDate >= startDate;
            });
          }
          if (endDate !== null) {
            var date = new Date(endDate);
            var day = 60 * 60 * 24 * 1000;
            var end = this.formatDate(new Date(date.getTime() + day));
            this.pendingList = await this.pendingList.filter(function (el) {
              return el.dueDate <= end;
            });
          }
          if (locationNetwork !== null) {
            this.pendingList = await this.pendingList.filter(function (el) {
              return el.locationNetworkId === locationNetwork;
            });
          }
          if (locationNode !== null) {
            this.pendingList = await this.pendingList.filter(function (el) {
              return el.locationNodeId === locationNode;
            });
          }
          if (switchingCentre !== null) {
            this.pendingList = await this.pendingList.filter(function (el) {
              return el.switchingCentreId === switchingCentre;
            });
          }
          if (created !== null) {
            this.pendingList = await this.pendingList.filter(function (el) {
              return el.createdById === created;
            });
          }
          this.pendingTotalItems = this.pendingList.length;
          this.keyPending++;
        }

        if (value.currentTab === "resolved") {
          this.resolvedList = this.initialResolved;

          if (currentStatus !== null) {
            this.resolvedList = await this.resolvedList.filter(function (el) {
              return el.currentStatus === currentStatus;
            });
          }
          if (importance !== null) {
            this.resolvedList = await this.resolvedList.filter(function (el) {
              return el.importance === importance;
            });
          }
          if (category !== null && categoryItem !== null) {
            this.resolvedList = await this.resolvedList.filter(function (el) {
              return el.ticketCategoryItemId === categoryItem;
            });
          } else if (category !== null && categoryItem === null) {
            this.resolvedList = await this.resolvedList.filter(function (el) {
              return el.ticketCategoryItem.ticketCategoryId === category;
            });
          }
          if (userRole !== null && assigned !== null) {
            this.resolvedList = await this.resolvedList.filter(function (el) {
              return el.assignedToId === assigned;
            });
          } else if (userRole !== null && assigned === null) {
            this.resolvedList = await this.resolvedList.filter(function (el) {
              return el.userRoleId === userRole;
            });
          }
          if (startDate !== null) {
            this.resolvedList = await this.resolvedList.filter(function (el) {
              return el.dueDate >= startDate;
            });
          }
          if (endDate !== null) {
            var date = new Date(endDate);
            var day = 60 * 60 * 24 * 1000;
            var end = this.formatDate(new Date(date.getTime() + day));
            this.resolvedList = await this.resolvedList.filter(function (el) {
              return el.dueDate <= end;
            });
          }
          if (locationNetwork !== null) {
            this.resolvedList = await this.resolvedList.filter(function (el) {
              return el.locationNetworkId === locationNetwork;
            });
          }
          if (locationNode !== null) {
            this.resolvedList = await this.resolvedList.filter(function (el) {
              return el.locationNodeId === locationNode;
            });
          }
          if (switchingCentre !== null) {
            this.resolvedList = await this.resolvedList.filter(function (el) {
              return el.switchingCentreId === switchingCentre;
            });
          }
          if (resolved !== null) {
            this.resolvedList = await this.resolvedList.filter(function (el) {
              return el.resolvedById === resolved;
            });
          }
          if (created !== null) {
            this.resolvedList = await this.resolvedList.filter(function (el) {
              return el.createdById === created;
            });
          }
          this.resolvedTotalItems = this.resolvedList.length;
          this.keyResolved++;
        }
        if (value.currentTab === "systemGenerated") {
          this.systemGeneratedList = this.initialSystemGenerated;

          if (currentStatus !== null) {
            this.systemGeneratedList = await this.systemGeneratedList.filter(
              function (el) {
                return el.currentStatus === currentStatus;
              }
            );
          }
          if (importance !== null) {
            this.systemGeneratedList = await this.systemGeneratedList.filter(
              function (el) {
                return el.importance === importance;
              }
            );
          }
          if (category !== null && categoryItem !== null) {
            this.systemGeneratedList = await this.systemGeneratedList.filter(
              function (el) {
                return el.ticketCategoryItemId === categoryItem;
              }
            );
          } else if (category !== null && categoryItem === null) {
            this.systemGeneratedList = await this.systemGeneratedList.filter(
              function (el) {
                return el.ticketCategoryItem.ticketCategoryId === category;
              }
            );
          }
          if (userRole !== null && assigned !== null) {
            this.systemGeneratedList = await this.systemGeneratedList.filter(
              function (el) {
                return el.assignedToId === assigned;
              }
            );
          } else if (userRole !== null && assigned === null) {
            this.systemGeneratedList = await this.systemGeneratedList.filter(
              function (el) {
                return el.userRoleId === userRole;
              }
            );
          }
          if (startDate !== null) {
            this.systemGeneratedList = await this.systemGeneratedList.filter(
              function (el) {
                return el.dueDate >= startDate;
              }
            );
          }
          if (endDate !== null) {
            var date = new Date(endDate);
            var day = 60 * 60 * 24 * 1000;
            var end = this.formatDate(new Date(date.getTime() + day));
            this.systemGeneratedList = await this.systemGeneratedList.filter(
              function (el) {
                return el.dueDate <= end;
              }
            );
          }
          if (locationNetwork !== null) {
            this.systemGeneratedList = await this.systemGeneratedList.filter(
              function (el) {
                return el.locationNetworkId === locationNetwork;
              }
            );
          }
          if (locationNode !== null) {
            this.systemGeneratedList = await this.systemGeneratedList.filter(
              function (el) {
                return el.locationNodeId === locationNode;
              }
            );
          }
          if (switchingCentre !== null) {
            this.systemGeneratedList = await this.systemGeneratedList.filter(
              function (el) {
                return el.switchingCentreId === switchingCentre;
              }
            );
          }
          if (resolved !== null) {
            this.systemGeneratedList = await this.systemGeneratedList.filter(
              function (el) {
                return el.resolvedById === resolved;
              }
            );
          }
          if (created !== null) {
            this.systemGeneratedList = await this.systemGeneratedList.filter(
              function (el) {
                return el.createdById === created;
              }
            );
          }
          this.systemGeneratedTotalItems = this.systemGeneratedList.length;
          this.keySystem++;
        }

        if (value.currentTab === "calendar") {
          /// this.filteredTickets = this.initialCalendar;
          let dates = [...new Set(this.allFilteredTickets.map((x) => x.dates))];

          let result = [];
          for (let i = 0; i < dates.length; i++) {
            let sliceData = this.allFilteredTickets
              .filter(
                (x) =>
                  x.customData.isSystemGenerated ===
                    this.calendarSystemGenerated &&
                  x.customData.isComplete === this.showCompletedTickets &&
                  x.dates === dates[i]
              )
              .slice(0, 3);
            result = [...result, ...sliceData];
          }
          this.filteredTickets = result;

          let newCalendar = this.filteredTickets.map((x) => ({
            assignedTo: x.customData.assignedTo,
            assignedToId: x.customData.assignedToId,
            colour: x.customData.colour,
            createdAt: x.customData.createdAt,
            createdBy: x.customData.createdBy,
            createdById: x.customData.createdById,
            currentStatus: x.customData.currentStatus,
            description: x.customData.description,
            dueDate: x.customData.dueDate,
            dueTime: x.customData.dueTime,
            id: x.customData.id,
            importance: x.customData.importance,
            isActive: x.customData.isActive,
            isComplete: x.customData.isComplete,
            isDeleted: x.customData.isDeleted,
            location: x.customData.location,
            locationId: x.customData.locationId,
            locationNetwork: x.customData.locationNetwork,
            locationNetworkId: x.customData.locationNetworkId,
            locationNode: x.customData.locationNode,
            locationNodeId: x.customData.locationNodeId,
            organisationId: x.customData.organisationId,
            resolvedBy: x.customData.resolvedBy,
            resolvedById: x.customData.resolvedById,
            switchingCentre: x.customData.switchingCentre,
            switchingCentreId: x.customData.switchingCentreId,
            ticketCategoryItem: x.customData.ticketCategoryItem,
            ticketCategoryItemId: x.customData.ticketCategoryItemId,
            updatedAt: x.customData.updatedAt,
            dates: x.dates,
            highlight: x.highlight,
          }));
          if (currentStatus !== null) {
            newCalendar = await newCalendar.filter(function (el) {
              return el.currentStatus === currentStatus;
            });
          }
          if (importance !== null) {
            newCalendar = await newCalendar.filter(function (el) {
              return el.importance === importance;
            });
          }
          if (category !== null && categoryItem !== null) {
            newCalendar = await newCalendar.filter(function (el) {
              return el.ticketCategoryItemId === categoryItem;
            });
          } else if (category !== null && categoryItem === null) {
            newCalendar = await newCalendar.filter(function (el) {
              return el.ticketCategoryItem.ticketCategoryId === category;
            });
          }
          if (userRole !== null && assigned !== null) {
            newCalendar = await newCalendar.filter(function (el) {
              return el.assignedToId === assigned;
            });
          } else if (userRole !== null && assigned === null) {
            newCalendar = await newCalendar.filter(function (el) {
              return el.userRoleId === userRole;
            });
          }
          if (startDate !== null) {
            newCalendar = await newCalendar.filter(function (el) {
              return el.dueDate >= startDate;
            });
          }
          if (endDate !== null) {
            var date = new Date(endDate);
            var day = 60 * 60 * 24 * 1000;
            var end = this.formatDate(new Date(date.getTime() + day));
            newCalendar = await newCalendar.filter(function (el) {
              return el.dueDate <= end;
            });
          }
          if (locationNetwork !== null) {
            newCalendar = await newCalendar.filter(function (el) {
              return el.locationNetworkId === locationNetwork;
            });
          }
          if (locationNode !== null) {
            newCalendar = await newCalendar.filter(function (el) {
              return el.locationNodeId === locationNode;
            });
          }
          if (switchingCentre !== null) {
            newCalendar = await newCalendar.filter(function (el) {
              return el.switchingCentreId === switchingCentre;
            });
          }
          if (resolved !== null) {
            newCalendar = await newCalendar.filter(function (el) {
              return el.resolvedById === resolved;
            });
          }
          if (created !== null) {
            newCalendar = await newCalendar.filter(function (el) {
              return el.createdById === created;
            });
          }
          this.filteredTickets = newCalendar.map((x) => ({
            customData: {
              assignedTo: x.assignedTo,
              assignedToId: x.assignedToId,
              colour: x.colour,
              createdAt: x.createdAt,
              createdBy: x.createdBy,
              createdById: x.createdById,
              currentStatus: x.currentStatus,
              description: x.description,
              dueDate: x.dueDate,
              dueTime: x.dueTime,
              id: x.id,
              importance: x.importance,
              isActive: x.isActive,
              isComplete: x.isComplete,
              isDeleted: x.isDeleted,
              location: x.location,
              locationId: x.locationId,
              locationNetwork: x.locationNetwork,
              locationNetworkId: x.locationNetworkId,
              locationNode: x.locationNode,
              locationNodeId: x.locationNodeId,
              organisationId: x.organisationId,
              resolvedBy: x.resolvedBy,
              resolvedById: x.resolvedById,
              switchingCentre: x.switchingCentre,
              switchingCentreId: x.switchingCentreId,
              ticketCategoryItem: x.ticketCategoryItem,
              ticketCategoryItemId: x.ticketCategoryItemId,
              updatedAt: x.updatedAt,
            },
            dates: x.dates,
            highlight: x.highlight,
          }));
        }

        if (value.currentTab === "allTicket") {
          this.allTicketList = this.initialAllTicket;

          if (currentStatus !== null) {
            this.allTicketList = await this.allTicketList.filter(function (el) {
              return el.currentStatus === currentStatus;
            });
          }
          if (importance !== null) {
            this.allTicketList = await this.allTicketList.filter(function (el) {
              return el.importance === importance;
            });
          }
          if (category !== null && categoryItem !== null) {
            this.allTicketList = await this.allTicketList.filter(function (el) {
              return el.ticketCategoryItemId === categoryItem;
            });
          } else if (category !== null && categoryItem === null) {
            this.allTicketList = await this.allTicketList.filter(function (el) {
              return el.ticketCategoryItem.ticketCategoryId === category;
            });
          }
          if (userRole !== null && assigned !== null) {
            this.allTicketList = await this.allTicketList.filter(function (el) {
              return el.assignedToId === assigned;
            });
          } else if (userRole !== null && assigned === null) {
            this.allTicketList = await this.allTicketList.filter(function (el) {
              return el.userRoleId === userRole;
            });
          }
          if (startDate !== null) {
            this.allTicketList = await this.allTicketList.filter(function (el) {
              return el.dueDate >= startDate;
            });
          }
          if (endDate !== null) {
            var date = new Date(endDate);
            var day = 60 * 60 * 24 * 1000;
            var end = this.formatDate(new Date(date.getTime() + day));
            this.allTicketList = await this.allTicketList.filter(function (el) {
              return el.dueDate <= end;
            });
          }
          if (locationNetwork !== null) {
            this.allTicketList = await this.allTicketList.filter(function (el) {
              return el.locationNetworkId === locationNetwork;
            });
          }
          if (locationNode !== null) {
            this.allTicketList = await this.allTicketList.filter(function (el) {
              return el.locationNodeId === locationNode;
            });
          }
          if (switchingCentre !== null) {
            this.allTicketList = await this.allTicketList.filter(function (el) {
              return el.switchingCentreId === switchingCentre;
            });
          }
          if (created !== null) {
            this.allTicketList = await this.allTicketList.filter(function (el) {
              return el.createdById === created;
            });
          }
          this.allTicketTotalItems = this.allTicketList.length;
          this.keyAllTicket++;
        }
      },
    },
    systemGeneratedTotalItems: {
      immediate: true,
      async handler(value) {
        this.tabs[5].array = value;
        this.tabs[5].color = "brown";
        this.key++;
      },
    },
    resolvedTotalItems: {
      immediate: true,
      async handler(value) {
        this.tabs[4].array = value;
        this.tabs[4].color = "green";
        this.key++;
      },
    },
    pendingTotalItems: {
      immediate: true,
      async handler(value) {
        this.tabs[3].array = value;
        this.tabs[3].color = "blue";
        this.key++;
      },
    },
    unassignedTotalItems: {
      immediate: true,
      async handler(value) {
        this.tabs[2].array = value;
        this.tabs[2].color = "orange";
        this.key++;
      },
    },
    allTicketTotalItems: {
      immediate: true,
      async handler(value) {
        this.tabs[1].array = value;
        this.tabs[1].color = "grey";
        this.key++;
      },
    },
    filteredTickets: {
      immediate: true,
      async handler(value) {
        if (value) {
          this.tabs[0].array = this.filteredTickets.length;
          this.tabs[0].color = "purple";
          this.key++;
        }
      },
    },
  },
  created() {
    ////this.isloading = true;
    this.$router.push({
      name: this.$route.name,
      query: {
        pendingOffset: "0",
        resolvedOffset: "0",
        unassignedOffset: "0",
        systemGeneratedOffset: "0",
        allTicketOffset: "0",
        records: "15",
      },
    });
    this.loadingTicket = true;
    this.fetchCalendar();
    this.setActiveTabName("allTicket");
    this.fetchAllTickets();

    this.fetchLocationNetworks();
    this.fetchSwitchingCentres();
    this.fetchLocationNodes();
    this.fetchOrgContacts();
    this.fetchUserRoles();
    this.getKeysList();
    this.fetchTicketTemplates();
    this.locationType = "End Location";
    this.key++;
  },
  methods: {
    calculateMoreShow(map, day) {
      if (this.filterModal == false) {
        let ans = Object.values(map.attributesMap);
        let data = this.allFilteredTickets.filter(
          (x) =>
            x.dates == day &&
            this.showCompletedTickets == x.customData.isComplete &&
            this.calendarSystemGenerated == x.customData.isSystemGenerated
        );

        if (this.filterCurrentStatus !== null) {
          data = data.filter(
            (y) => y.customData.currentStatus === this.filterCurrentStatus
          );
        }
        if (this.filterImportance !== null) {
          data = data.filter(
            (y) => y.customData.importance === this.filterImportance
          );
        }
        if (
          this.filterTicketCategory !== null &&
          this.filterTicketCategoryItem !== null
        ) {
          data = data.filter(
            (el) =>
              el.customData.ticketCategoryItemId ===
              this.filterTicketCategoryItem
          );
        } else if (
          this.filterTicketCategory !== null &&
          this.filterTicketCategoryItem === null
        ) {
          data = data.filter(
            (el) =>
              el.customData.ticketCategoryItem.ticketCategoryId ===
              this.filterTicketCategory
          );
        }
        if (this.filterUserRole !== null && this.filterAssignedToId !== null) {
          data = data.filter(
            (el) => el.customData.assignedToId === this.filterAssignedToId
          );
        } else if (
          this.filterUserRole !== null &&
          this.filterAssignedToId === null
        ) {
          data = data.filter(
            (el) => el.customData.userRoleId === this.filterUserRole
          );
        }
        if (this.filterStartDate !== null) {
          data = data.filter(
            (el) => el.customData.dueDate >= this.filterStartDate
          );
        }
        if (this.filterEndDate !== null) {
          var date = new Date(this.filterEndDate);
          var day = 60 * 60 * 24 * 1000;
          var end = this.formatDate(new Date(date.getTime() + day));
          data = data.filter((el) => el.customData.dueDate <= end);
        }
        if (this.filterNetwork !== null) {
          data = data.filter(
            (el) => el.customData.locationNetworkId === this.filterNetwork
          );
        }
        if (this.filterNode !== null) {
          data = data.filter(
            (el) => el.customData.locationNodeId === this.filterNode
          );
        }
        if (this.filterSwitchingCentre !== null) {
          data = data.filter(
            (el) =>
              el.customData.switchingCentreId === this.filterSwitchingCentre
          );
        }
        if (this.filterCreatedId !== null) {
          data = data.filter(
            (el) => el.customData.createdById === this.filterCreatedId
          );
        }
        if (this.filterResolvedId !== null) {
          data = data.filter(
            (el) => el.customData.resolvedById === this.filterResolvedId
          );
        }

        if (data.length > 3 && ans.length >= 3) {
          return true;
        } else {
          return false;
        }
      } else if (this.filterModal == true) {
        let ans = Object.values(map.attributesMap);
        let data = this.allFilteredTickets.filter(
          (x) =>
            x.dates == day &&
            this.showCompletedTickets == x.customData.isComplete &&
            this.calendarSystemGenerated == x.customData.isSystemGenerated
        );
        if (data.length > 3 && ans.length >= 3) {
          return true;
        } else {
          return false;
        }
      }
    },
    calculateMore(day) {
      let data = this.filteredTickets.filter(
        (x) =>
          x.dates === day &&
          this.showCompletedTickets === x.customData.isComplete &&
          this.calendarSystemGenerated === x.customData.isSystemGenerated
      );
      if (data.length === 3) {
        return true;
      } else {
        return false;
      }
    },
    async showMoreButton(day, map) {
      this.loadingMore = true;
      let mapped = await Object.values(map).map((x) => x.customData.id);
      let sliceData = await this.allFilteredTickets.filter(
        (x) =>
          x.dates === day &&
          x.customData.id !== mapped[0] &&
          x.customData.id !== mapped[1] &&
          x.customData.id !== mapped[2] &&
          this.showCompletedTickets === x.customData.isComplete &&
          this.calendarSystemGenerated === x.customData.isSystemGenerated
      );
      this.filteredTickets = [...this.filteredTickets, ...sliceData];
      this.loadingMore = false
    },
    async showLessButton(day, map) {
      this.loadingMore = true
      let mapped = await Object.values(map).map((x) => x.customData.id).slice(3, Object.values(map).length);

      let sliceData = await this.filteredTickets.filter(
        (x) =>
          !mapped.includes(x.customData.id) &&
          this.showCompletedTickets === x.customData.isComplete &&
          this.calendarSystemGenerated === x.customData.isSystemGenerated
      );
      this.filteredTickets = sliceData;
      this.loadingMore = false
    },
    async getKeysList() {
      Api()
        .get("/ticketCategory/keys")
        .then((response) => {
          this.categoryList = response.data;
          this.categoryItemList = response.data;
        });
    },
    filterByKey(data) {
      this.filterTicketCategory = data.item.ticketCategoryId;
      this.filterTicketCategoryItem = data.item.id;
      this.filterCalendar = true;
    },
    filterByCategory(data) {
      this.filterTicketCategory = data.item.id;
      this.filterCalendar = true;
    },
    clearKeys() {
      let dates = [...new Set(this.allFilteredTickets.map((x) => x.dates))];
      this.filteredTickets = [];
      let result = [];
      for (let i = 0; i < dates.length; i++) {
        let sliceData = this.allFilteredTickets
          .filter((x) => x.dates === dates[i])
          .slice(0, 3);
        result = [...result, ...sliceData];
      }
      this.filteredTickets = result;
      // if(this.keyComplete === null || this.keyComplete ==='undefined' || typeof(this.keyComplete) ==='undefined'){

      this.filterTicketCategory = null;
      this.filterTicketCategoryItem = null;
      // this.filterCalendar = true
      // }
    },
    clearFilters() {
      (this.filterNetwork = null),
        (this.filterNode = null),
        (this.filterSwitchingCentre = null),
        (this.filterUserRole = null),
        (this.filterStartDate = null),
        (this.filterEndDate = null),
        (this.filterTicketCategory = null),
        (this.filterTicketCategoryItem = null),
        (this.filterCurrentStatus = null),
        (this.filterImportance = null),
        (this.filterAssignedToId = null),
        (this.filterResolvedId = null),
        (this.filterCreatedId = null),
        (this.locationType = "End Location");
      this.filterModal = true;
    },
    fetchAllTickets() {
      Api()
        .get("/ticket/all", {
          params: {
            search: this.$route.query.allTicketSearch,
            offset: "0",
            records: this.$route.query.records,
          },
        })
        .then((response) => {
          this.initialAllTicket = response.data.result;
          this.key++;
        });
      Api()
        .get("/ticket/active", {
          params: {
            search: this.$route.query.pendingSearch,
            offset: "0",
            records: this.$route.query.records,
          },
        })
        .then((response) => {
          this.initialPending = response.data.result;
          this.key++;
        });
      Api()
        .get("/ticket/resolved", {
          params: {
            search: this.$route.query.resolvedSearch,
            offset: "0",
            records: this.$route.query.records,
          },
        })
        .then((response) => {
          this.initialResolved = response.data.result;
          this.key++;
        });
      Api()
        .get("/ticket/unassigned", {
          params: {
            search: this.$route.query.unassignedSearch,
            offset: "0",
            records: this.$route.query.records,
          },
        })
        .then((response) => {
          this.initialUnassigned = response.data.result;
          this.key++;
        });
      Api()
        .get("/ticket/systemGenerated", {
          params: {
            search: this.$route.query.systemGeneratedSearch,
            offset: "0",
            records: this.$route.query.records,
          },
        })
        .then((response) => {
          this.initialSystemGenerated = response.data.result;
          this.key++;
        });
    },
    clearFiltersButton() {
      (this.filterNetwork = null),
        (this.filterNode = null),
        (this.filterSwitchingCentre = null),
        (this.filterUserRole = null),
        (this.filterStartDate = null),
        (this.filterEndDate = null),
        (this.filterTicketCategory = null),
        (this.filterTicketCategoryItem = null),
        (this.filterCurrentStatus = null),
        (this.filterImportance = null),
        (this.filterAssignedToId = null),
        (this.filterResolvedId = null),
        (this.filterCreatedId = null),
        (this.locationType = "End Location");
      if (this.displayContents("resolved") === true) {
        Api()
          .get("/ticket/resolved", {
            params: {
              offset: "0",
              records: this.$route.query.records,
            },
          })
          .then((response) => {
            this.resolvedList = response.data.result;
            this.resolvedTotalItems = response.data.count;
            this.keyResolved++;
            this.filterModal = false;
          });
      } else if (this.displayContents("unassigned") === true) {
        Api()
          .get("/ticket/unassigned", {
            params: {
              offset: "0",
              records: this.$route.query.records,
            },
          })
          .then((response) => {
            this.unassignedList = response.data.result;
            this.unassignedTotalItems = response.data.count;
            this.keyUnassigned++;
            this.filterModal = false;
          });
      } else if (this.displayContents("pending") === true) {
        Api()
          .get("/ticket/active", {
            params: {
              offset: "0",
              records: this.$route.query.records,
            },
          })
          .then((response) => {
            this.pendingList = response.data.result;
            this.pendingTotalItems = response.data.count;
            this.keyPending++;
            this.filterModal = false;
          });
      } else if (this.displayContents("systemGenerated") === true) {
        Api()
          .get("/ticket/systemGenerated", {
            params: {
              offset: "0",
              records: this.$route.query.records,
            },
          })
          .then((response) => {
            this.systemGeneratedList = response.data.result;
            this.systemGeneratedTotalItems = response.data.count;
            this.keySystem++;
            this.filterModal = false;
          });
      } else if (this.displayContents("allTicket") === true) {
        Api()
          .get("/ticket/all", {
            params: {
              offset: "0",
              records: this.$route.query.records,
            },
          })
          .then((response) => {
            this.allTicketList = response.data.result;
            this.allTicketTotalItems = response.data.count;
            this.keyAllTicket++;
            this.filterModal = false;
          });
      } else if (this.displayContents("calendar") === true) {
        this.fetchCalendar();
        this.filterModal = false;
      }
    },
    specifyTab() {
      if (this.displayContents("unassigned") === true) {
        this.filterUnassigned = true;
      } else if (this.displayContents("pending") === true) {
        this.filterPending = true;
      } else if (this.displayContents("resolved") === true) {
        this.filterResolved = true;
      } else if (this.displayContents("systemGenerated") === true) {
        this.filterSystemGenerated = true;
      } else if (this.displayContents("calendar") === true) {
        this.filterCalendar = true;
      } else if (this.displayContents("allTicket") === true) {
        this.filterAllTicket = true;
      }
    },
    fetchUserRoles() {
      Api()
        .get("/userRole")
        .then((response) => {
          this.userRoles = response.data;
        });
    },
    fetchSwitchingCentres() {
      //this.loadingTicket=true
      ////this.isloading=true
      Api()
        .get("/switchingCentres")
        .then((response) => {
          this.switchingCentres = response.data;
          //this.loadingTicket=false
          ////this.isloading=false
        });
    },
    fetchLocationNodes() {
      //this.loadingTicket=true
      ////this.isloading=true
      Api()
        .get("/locationNodes")
        .then((response) => {
          this.locationNodes = response.data;
          //this.loadingTicket=false
          ////this.isloading=false
        });
    },
    fetchLocationNetworks() {
      //this.loadingTicket=true
      ////this.isloading=true
      Api()
        .get("/locationNetworks")
        .then((response) => {
          this.locationNetworks = response.data;
          //this.loadingTicket=false
          ////this.isloading=false
        });
    },
    lastday(y, m) {
      return new Date(y, m, 0).getDate();
    },
    fetchCalendar() {
      //this.loadingTicket=true
      ////this.isloading=true
      let d = new Date();
      let month = d.getMonth() + 1;
      let start = d.getFullYear() + "-" + ("0" + month).slice(-2) + "-01";
      let end =
        d.getFullYear() +
        "-" +
        ("0" + month).slice(-2) +
        "-" +
        this.lastday(d.getFullYear(), month);
      Api()
        .get("/ticket/month/" + start + "/" + end)
        .then((response) => {
          this.initialCalendar = response.data;
          // this.filteredTickets = response.data;
          this.calendarSystemGenerated = false;
          this.showCompletedTickets = false;
          this.loadingTicket = false;
          this.allFilteredTickets = response.data;
          let dates = [...new Set(this.allFilteredTickets.map((x) => x.dates))];

          let result = [];
          for (let i = 0; i < dates.length; i++) {
            let sliceData = this.allFilteredTickets
              .filter((x) => x.dates === dates[i])
              .slice(0, 3);
            result = [...result, ...sliceData];
          }
          this.filteredTickets = result;
        });
    },
    async changeCal() {
      this.loadingTicket = true;
      this.calendarSystemGenerated = null;
      let start =
        this.$refs.calendar.pages[0].year +
        "-" +
        ("0" + this.$refs.calendar.pages[0].month).slice(-2) +
        "-01";
      let end =
        this.$refs.calendar.pages[0].year +
        "-" +
        ("0" + this.$refs.calendar.pages[0].month).slice(-2) +
        "-" +
        this.$refs.calendar.pages[0].monthComps.days;

      Api()
        .get("/ticket/month/" + start + "/" + end)
        .then((response) => {
          this.initialCalendar = response.data;
          this.filteredTickets = response.data;
          this.allFilteredTickets = response.data;
          let dates = [...new Set(this.allFilteredTickets.map((x) => x.dates))];

          let result = [];
          for (let i = 0; i < dates.length; i++) {
            let sliceData = this.allFilteredTickets
              .filter(
                (x) => !x.customData.isSystemGenerated && x.dates === dates[i]
              )
              .slice(0, 3);
            result = [...result, ...sliceData];
          }
          this.filteredTickets = result;
          this.calendarSystemGenerated = false;
          //this.key++;
          this.loadingTicket = false;
        });
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    clearTemplate() {
      this.ticketItem.dueDate = "";
      this.ticketItem.dueTime = "";
      this.ticketItem.assignedToId = null;
      this.ticketItem.ticketCategoryItemId = null;
      this.ticketItem.ticketCategoryId = null;
    },
    populateTemplate() {
      this.clearTemplate();
      for (let i = 0; i < this.ticketTemplates.length; i++) {
        if (this.ticketTemplates[i].id === this.ticketItem.ticketTemplateId) {
          this.ticketItem.dueDate = this.ticketTemplates[i].dueDate;
          this.ticketItem.dueTime = this.ticketTemplates[i].dueTime;
          this.ticketItem.assignedToId = this.ticketTemplates[i].contactId;
          if (this.ticketTemplates[i].ticketCategoryItem !== null) {
            this.ticketItem.ticketCategoryItemId = this.ticketTemplates[
              i
            ].ticketCategoryItemId;
            this.ticketItem.ticketCategoryId = this.ticketTemplates[
              i
            ].ticketCategoryItem.ticketCategoryId;
          }
        }
      }
    },
    resetTable() {
      //this.fetchTickets();
    },
    async filterTickets() {
      let tempPackages = [];
      this.filteredTickets = [];
      for (let i = 0; i < this.tickets.length; i++) {
        if (this.tickets[i].assignedToId == this.contactId) {
          tempPackages.push(this.tickets[i]);
        }
      }

      tempPackages.sort((a, b) => new Date(b.dueDate) - new Date(a.dueDate));
      let tempuser = this.$store.state.user;
      this.filteredTickets = tempPackages;

      await this.filteredTickets.forEach(function (element) {
        (element.fullNameAssigned =
          element.assignedTo.name + " " + element.assignedTo.surname),
          (element.fullNameCreated =
            element.createdBy.name + " " + element.createdBy.surname);
        if (element.isComplete === true) {
          if (element.resolvedById === null) {
            element.resolvedById = tempuser.id;
            element.fullNameResolved = tempuser.name + " " + tempuser.surname;
          }
        }
      });
    },
    async editTicket(item) {
      this.$router.push({ path: "/ticketSummary/" + item });
    },
    fetchTicketTemplates() {
      Api()
        .get("/ticketTemplate")
        .then((response) => {
          this.ticketTemplates = response.data;
          this.loadingTicket = false;
        });
    },
    fetchTicketCategoryItems() {
      Api()
        .get("/ticketCategoryItem")
        .then((response) => {
          this.ticketCategoryItems = response.data;
        });
    },
    fetchTicketComments(id) {
      Api()
        .get("/ticketComment/byTicket/" + id)
        .then((response) => {
          this.ticketCommentLog = response.data;
        });
    },
    fetchTicketAssignments(id) {
      Api()
        .get("/ticketAssignLog/byTicket/" + id)
        .then((response) => {
          this.ticketAssignedLog = response.data;
        });
    },
    addComment(comment) {
      this.ticketCommentLog.push({
        commentedBy: this.$store.state.user,
        commentedById: this.$store.state.user.id,
        comment: comment,
        type: "comment",
        createdAt: new Date(),
      });
      this.comment = "";
      this.addCommentBox = false;
    },
    addCommentEditedTicket(comment) {
      Api()
        .post("/ticketComment", {
          ticketId: this.ticketItem.id,
          type: "comment",
          commentedById: this.$store.state.user.id,
          comment: comment,
        })
        .then((response) => {
          response.data.commentedBy = this.$store.state.user;
          this.ticketCommentLog.push(response.data);
          this.comment = "";
          this.addCommentBox = false;
        });
    },
    filterObject(item, queryText, itemText) {
      return (
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1 ||
        item.surname
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },

    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
    formatTime(date) {
      if (date !== null) {
        return dateformat(date, "HH:MM");
      } else {
        null;
      }
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    addTicket() {
      this.ticketItem = {
          importance: "Normal",
          currentStatus: "Pending",
          dueDate: this.formatDate(new Date()),
          documents: []
        };
        this.viewTicket = true
      // this.locationFilter = null;
      // if (date == null) {
      //   this.addTicketModal = true;
      //   this.ticketItem = {
      //     importance: "Normal",
      //     currentStatus: "Pending",
      //     dueDate: this.formatDate(new Date()),
      //   };
      // } else {
      //   this.ticketItem = {
      //     importance: "Normal",
      //     currentStatus: "Pending",
      //     dueDate: this.formatDate(new Date(date)),
      //   };
      //   this.addTicketModal = true;
      // }
    },
    async createNewTicket() {
      this.loadingTicket = true;
      this.ticketItem.formRequired = this.ticketcategoryitems.filter(x=>x.id ==this.ticketItem.ticketCategoryItemId)[0].formRequired
      
      await Api()
        .post("/ticket", this.ticketItem)
        .then((response) => {
          this.key++;
          if (this.ticketCommentLog.length > 0) {
            for (let i = 0; i < this.ticketCommentLog.length; i++) {
              this.ticketCommentLog[i].ticketId = response.data.id;
            }
            Api()
              .post("/ticketComment", {
                batch: this.ticketCommentLog,
              })
              .then((response) => {});
          }
          if (this.ticketItem.assignedToId) {
            Api().post("/ticketAssignLog", {
              assignedToId: this.ticketItem.assignedToId,
              assignedById: this.$store.state.user.id,
              ticketId: response.data.id,
            });
          }
          (this.locationNetworkId = null),
            (this.locationNodeId = null),
            (this.switchingCentreId = null);
          if (this.$refs.calendar) {
        this.calendarSystemGenerated= null,
        this.showCompletedTickets= null
             let d = new Date();
      let month = d.getMonth() + 1;
      let start = d.getFullYear() + "-" + ("0" + month).slice(-2) + "-01";
      let end =
        d.getFullYear() +
        "-" +
        ("0" + month).slice(-2) +
        "-" +
        this.lastday(d.getFullYear(), month);
      Api()
        .get("/ticket/month/" + start + "/" + end)
        .then((response) => {
          this.initialCalendar = response.data;
          // this.filteredTickets = response.data;
          this.calendarSystemGenerated = false;
          this.showCompletedTickets = false;
          this.loadingTicket = false;
          this.allFilteredTickets = response.data;
          let dates = [...new Set(this.allFilteredTickets.map((x) => x.dates))];

          let result = [];
          for (let i = 0; i < dates.length; i++) {
            let sliceData = this.allFilteredTickets
              .filter((x) => x.dates === dates[i])
              .slice(0, 3);
            result = [...result, ...sliceData];
          }
          this.filteredTickets = result;
        });
          }
          Api()
            .get("/ticket/active", {
              params: {
                search: this.$route.query.pendingSearch,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.pendingList = response.data.result;
              this.pendingTotalItems = response.data.count;
              this.keyPending++;
              this.loadingTicket = false;
            });
          Api()
            .get("/ticket/unassigned", {
              params: {
                search: this.$route.query.unassignedSearch,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.unassignedList = response.data.result;
              this.unassignedTotalItems = response.data.count;
              this.keyUnassigned++;
              this.loadingTicket = false;
            });
          Api()
            .get("/ticket/all", {
              params: {
                search: this.$route.query.allTicketSearch,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.allTicketList = response.data.result;
              this.allTicketTotalItems = response.data.count;
              this.keyAllTicket++;
              this.loadingTicket = false;
            });
        });
      this.addTicketModal = false;
      this.viewTicket=false
      this.ticketItem = {};
    },

    handleChildDragstart(data, event) {
      event.stopPropagation();
      this.overData = data;
    },
    dropTicket(e, day) {
      this.over = false;
      this.overData.dueDate = day.id;
      Api()
        .put("/ticket/" + this.overData.id, {
          dueDate: day.id,
        })
        .then((response) => {
          (this.locationNetworkId = null),
            (this.locationNodeId = null),
            (this.switchingCentreId = null);
          let start =
            this.$refs.calendar.pages[0].year +
            "-" +
            ("0" + this.$refs.calendar.pages[0].month).slice(-2) +
            "-01";
          let end =
            this.$refs.calendar.pages[0].year +
            "-" +
            ("0" + this.$refs.calendar.pages[0].month).slice(-2) +
            "-" +
            this.$refs.calendar.pages[0].monthComps.days;

          Api()
            .get("/ticket/month/" + start + "/" + end)
            .then(async (response) => {
              this.allFilteredTickets = response.data;
              this.filteredTickets = response.data;
            });
        });
    },

    sortedDate(date) {
      return (
        new Date(date.toDateString()) >= new Date(new Date().toDateString())
      );
    },
    fetchOrgContacts() {
      this.filteredUsers = [];
      Api()
        .get("/organisationContact")
        .then(async (response) => {
          this.filteredUsers = response.data.filter(function (el) {
            return el.userType !== "endClient";
          });
          let contactArray = await this.filteredUsers.map((x) => x.contact);
          this.filteredUsers = contactArray;
        });
    },
    addTicketItem() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.addTicket();
        this.ticketAssignedLog = [];
        this.ticketCommentLog = [];
      }
    },
    refreshTickets(){
      Api()
            .get("/ticket/active", {
              params: {
                search: this.$route.query.pendingSearch,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.pendingList = response.data.result;
              this.pendingTotalItems = response.data.count;
              this.keyPending++;
              this.loadingTicket = false;
            });
          Api()
            .get("/ticket/unassigned", {
              params: {
                search: this.$route.query.unassignedSearch,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.unassignedList = response.data.result;
              this.unassignedTotalItems = response.data.count;
              this.keyUnassigned++;
              this.loadingTicket = false;
            });
          Api()
            .get("/ticket/all", {
              params: {
                search: this.$route.query.allTicketSearch,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.allTicketList = response.data.result;
              this.allTicketTotalItems = response.data.count;
              this.keyAllTicket++;
              this.loadingTicket = false;
            });
    }
  },
};
</script>
<style>
.completeCard {
  border: 5px solid red;
}
.smallText {
  font-size: 12px;
}
.text {
  display: block;
  width: 90%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  size: 15px;
}
.longText {
  display: block;
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  size: 15px;
}
.rounded-card {
  border-radius: 50px;
}
.custom {
  height: "100%" !important;
}
.custom_calendar {
  max-width: 90%;
}
.custom_calendar .vc-day {
  border-right: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
  padding: 3px;
}
.custom_calendar .on-top {
  border-top: 1px solid #aaa;
}
.custom_calendar .on-left {
  border-left: 1px solid #aaa;
}
.custom_calendar .event {
  word-wrap: break-word;
  word-break: break-all;
}
.custom_calendar .event-badge {
  white-space: normal;
  margin-top: 2px;
  text-align: left;
}
.event-badge {
  color: #fff;
}
.v-chip.complete {
  background: rgb(80, 189, 80);
}
.v-chip.incomplete {
  background: red;
}
.v-chip.canceled {
  background: red;
}
.v-chip.pending {
  background: orange;
}
.v-chip.inprogress {
  background: lightblue;
}
.v-chip.normal {
  background: grey;
}
.v-chip.average {
  background: rgb(70, 128, 236);
}
.v-chip.notcritical {
  background: rgb(231, 137, 14);
}
.v-chip.urgent {
  background: red;
}
.dropClass {
  height: 100%;
  margin: 0;
}
.drop.over {
  border-color: #aaa;
  background: #ccc;
}
</style>